<template>
  <div class="reg-ate">
    <template v-if="statusGeral === ''">
      <chat-window 
      ref="chat"
      :currentUserId="$store.state.token.clu_iu"
      :current-user-id="$store.state.token.clu_iu"
      :rooms="assuntos"
      :roomId="roomId"
      :room-id="roomId"
      :messages="[ '', null, undefined ].indexOf(assuntos) === -1 && assuntos.length >= 1 ? messages : []"
      :loadingRooms="statusRooms"
      :loading-rooms="statusRooms"
      :roomsLoaded="carregouTudoRooms"
      :rooms-loaded="carregouTudoRooms"
      :loadFirstRoom="false"
      :load-first-room="false"
      :showEmojis="false"
      :show-emojis="false"
      :statusMessage="statusMessage"
      :status-message="statusMessage"
      :messagesLoaded="carregouTudoMessage"
      :messages-loaded="carregouTudoMessage"
      :textMessages="traducao"
      :text-messages="traducao"
      :height="'calc(100% - 0px)'"
      @addRoom="regAteTimeLineCriarAssunto"
      @add-room="regAteTimeLineCriarAssunto"
      @sendMessage="regAteTimeLineEnviarMensagem"
      @send-message="regAteTimeLineEnviarMensagem"
      @typingMessage="regAteTimeLineEnviarTyping"
      @typing-message="regAteTimeLineEnviarTyping"
      @fetchMessages="regAteTimeLineAlterarAssunto"
      @fetch-messages="regAteTimeLineAlterarAssunto">
        <template v-slot:rooms-header>
          <div class="vac-box-search reg-ate-search" v-show="statusRooms === false">
            <!-- FILTAR -->
            <div class="icones fechar" @click="regAteTimeLineFechar">
              <svg class="fa fa-times"></svg>
            </div>

            <!-- ICONE INPUT BUSCA -->
            <div class="vac-icon-search" @click="() => { regAteTimeLineReiniciarTela(null, false, true) }" >
              <svg class="fas fa-search"></svg>
            </div>

            <!-- INPUT BUSCA -->
            <input type="search" class="vac-input" placeholder="Digite sua pesquisa" autocomplete="off" :class="filtroBusca === '' ? '' : 'buscando'" @keyup.enter="regAteTimeLineReiniciarTela" v-model="filtroBusca">
            
            <!-- SETA O ICONE PARA LIMPAR A BUSCA -->
            <div class="limpar-search" @click="() => { filtroBusca = ''; roomId = ''; regAteTimeLineReiniciarTela(null, true) }">
              <i class="fa fa-times" aria-hidden="true"></i>
            </div>

            <!-- FILTAR -->
            <div :key="'filtro-' + time" class="icones" v-if="Object.keys(filtros).length >= 1" @click="regAteTimeLineFiltroClick" :class="filtros.filtrando === true ? 'piscando' : ''" style="margin-left: 13px;">
              <svg class="fas fa-filter"></svg>
            </div>

            <!-- INICIAR ASSUNTO -->
            <div class="icones vac-add-icon" @click="regAteTimeLineCriarAssunto">
              <svg class="fas fa-plus"></svg>
            </div>
          </div>
        </template>

        <template v-slot:room-list-item="{ room }">
          <div class="vac-room-avatar reg-ate-avatar" :style="'margin-right: 5px; background: ' + room.cor_res.fundo + '; border: 1px solid ' + room.cor_res.borda + '; ' + 'color: ' + room.cor_res.letra + ';'" :title="'Responsável: ' + room.responsavel.id + ' - ' + room.responsavel.usuario">
            <!-- COLOCA A IMAGEM DO USUARIO -->
            <img v-if="[ '', null, undefined ].indexOf(room.responsavel.imagem) === -1" :src="room.responsavel.imagem" />

            <!-- COLOCA A INICIAL DO USUARIO -->
            <span v-else v-html="room.responsavel.inicial"></span>
          </div>

          <div class="vac-name-container vac-text-ellipsis">
            <!-- SETA O NOME DO ATENDIMENTO E DATA/HORA -->
            <div class="vac-title-container">
              <div class="vac-room-name vac-text-ellipsis">
                <span v-if="[ '', null, undefined ].indexOf(room.clu) === -1" :title="room.clu" v-html="room.clu + ' - '"></span>
                <span :title="room.roomName" v-html="room.roomName"></span>
              </div>
              <div class="vac-text-date" v-html="room.timestamp" :title="room.datahora"></div>
            </div>

            <div class="vac-text-last">
              <div class="vac-text-ellipsis">
                <div class="vac-text-ellipsis">
                  <!-- SETA A MENSAGEM RECEBIDA -->
                  <span target="_blank" class="vac-text-ellipsis" :title="'Assunto: ' + room.comentario" v-html="room.comentario" v-if="room.typingUsers.length === 0"></span>

                  <!-- SETA A MENSAGEM DE DIGITANDO  -->
                  <span class="vac-text-ellipsis reg-ate-typing" v-else>
                    {{ $store.state.usuarios.filter(item => item.id === room.typingUsers[0].toString())[0].usuario }} está digitando uma mensagem...
                  </span>
                </div>
              </div>

              <!-- VERIFICA SE DEVE MOSTRAR A QUANTIDADE DE MENSAGENS NÃO LIDOS -->
              <div class="vac-room-badge reg-ate-nlidos" v-if="room.unreadCount >= 1" :title="room.unreadCount + (room.unreadCount >= 2 ? ' Mensagens não lidas' : ' Mensagem não lida')" v-html="room.unreadCount"></div>

              <!-- SETA A INFORMAÇÃO DO STATUS -->
              <div class="vac-room-badge reg-ate-status" :style="'background: ' + room.cor_sta.fundo + '; border: 1px solid ' + room.cor_sta.borda + '; ' + 'color: ' + room.cor_sta.letra + ';'" v-html="room.id_status_nome_inicial" :title="'Status: ' + room.id_status_nome"></div>

              <!-- SETA A INFORMAÇÃO DA FORMA DE CONTATO -->
              <div class="vac-room-badge reg-ate-forma" :title="'Comunicação: ' + room.id_forma_contato_nome">
                <svg :class="room.id_forma_contato_icone" v-if="[ '', null, undefined ].indexOf(room.id_forma_contato_icone) === -1"></svg>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:no-room-selected>
          &nbsp;
        </template>

        <template v-slot:room-header-info="{ room }">
          <div class="svg-button toggle-button reg-ate-ocultar-assuntos" @click="regAteTimeLineMostrarOcultarAssuntos">
            <svg class="fas fa-arrow-left"></svg>
          </div>

          <div class="vac-info-wrapper">
            <div class="vac-name-container vac-text-ellipsis">
              <!-- SETA O NOME DO ATENDIMENTO E DATA/HORA -->
              <div class="vac-title-container">
                <div class="vac-room-name vac-text-ellipsis" style="cursor: pointer;" :title="room.roomName" @click="regAteTimeLineAbrirCadastro(room.id_contato)">
                  <span v-if="[ '', null, undefined ].indexOf(room.clu) === -1" v-html="room.clu + ' - '"></span>
                  <span v-html="room.roomName"></span>
                </div>
              </div>

              <div class="vac-text-last">
                <div class="vac-text-ellipsis">
                  <div class="vac-text-ellipsis">
                    <!-- SETA A MENSAGEM RECEBIDA -->
                    <div class="vac-text-ellipsis" v-if="room.typingUsers.length === 0">
                      <div class="vac-room-badge reg-ate-forma" :title="'Comunicação: ' + room.id_forma_contato_nome" v-if="[ '', null, undefined ].indexOf(room.id_forma_contato_icone) === -1" style="max-width: 23px; display: inline-block;">
                        <svg :class="room.id_forma_contato_icone"></svg>
                      </div>

                      <span target="_blank" :title="'Assunto: ' + room.comentario" v-html="room.comentario" ></span>
                    </div>

                    <!-- SETA A MENSAGEM DE DIGITANDO  -->
                    <span class="vac-text-ellipsis reg-ate-typing" v-else>
                      {{ $store.state.usuarios.filter(item => item.id === room.typingUsers[0].toString())[0].usuario }} está digitando uma mensagem...
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="[ '', null, undefined ].indexOf(cabecalhoEditar) === -1" class="vac-name-container reg-ate-time-line-cab-editar" @click='regAteTimeLineCabecalhoAlterarEditar'>
              <!-- SETA O CAMPO RESPONSAVEL -->
              <div class="reg-ate-avatar-clu" :style="'background: ' + room.cor_res.fundo + '; border: 1px solid ' + room.cor_res.borda + '; ' + 'color: ' + room.cor_res.letra + ';'" :title="'Responsável: ' + room.responsavel.id + ' - ' + room.responsavel.usuario">
                <!-- COLOCA A IMAGEM DO USUARIO -->
                <img v-if="[ '', null, undefined ].indexOf(room.responsavel.imagem) === -1" :src="room.responsavel.imagem" />

                <!-- COLOCA A INICIAL DO USUARIO -->
                <span v-else v-html="room.responsavel.inicial"></span>
              </div>

              <!-- SETA O CAMPO STATUS DO ASSUNTO -->
              <div :style="'background: ' + room.cor_sta.fundo + '; border: 1px solid ' + room.cor_sta.borda + '; ' + 'color: ' + room.cor_sta.letra + ';'" v-html="room.id_status_nome_inicial" :title="'Status: ' + room.id_status_nome"></div>
            </div>
          </div>
          
          <div class="vac-svg-button vac-room-options" @click="regAteTimeLineAbrirOpcoes('assunto')">
            <i class="fas fa-ellipsis-v"></i>
          </div>

          <template v-if="opcoes.indexOf('assunto') !== -1">
            <div class="vac-menu-options-bg" @click="regAteTimeLineAbrirOpcoes('assunto')"></div>
            <div class="vac-menu-options">
              <div class="vac-menu-list">
                <!-- BOTÃO PARA APAGAR O ASSUNTO -->
                <div>
                  <div class="vac-menu-item" @click="regAteTimeLineOpcoesOnClick('delete_room', room, 'assunto')">Apagar conversa</div>
                </div>

                <!-- FAZ O BOTÃO PARA CONEXÃO SUPORTE -->
                <div>
                  <div class="vac-menu-item" @click="regAteTimeLineOpcoesOnClick('suporte', room, 'assunto')">Conectar SuporteRF</div>
                </div>
              </div>
            </div>
          </template>
        </template>

        <template v-slot:message="{ message }">
          <div class="vac-message-container vac-message-container-offset">
            <div class="vac-message-card noselect reg-ate-msg-excluida" :class="message.senderId === $store.state.token.clu_iu ? 'vac-message-current' : ''" v-if="message.excluido === true">
              <div>
                <svg class="fas fa-ban"></svg>
                <span v-html="message.senderId === $store.state.token.clu_iu ? 'Você apagou essa mensagem' : 'Essa mensagem foi apagada'"></span>
              </div>
            </div>

            <div v-else class="vac-message-card" :class="message.senderId === $store.state.token.clu_iu ? 'vac-message-current' : ''">
              <!-- SETA O NOME DO USUARIO -->
              <div class="vac-text-username" v-if="message.senderId !== $store.state.token.clu_iu">
                <span v-html="message.username" :style="'color: ' + message.usuario_cor.fundo + ';'"></span>
              </div>

              <!-- VERIFICA SE TEM RESPOSTA -->
              <div class="vac-reply-message" v-if="[ '', null, undefined ].indexOf(message.vetor_resposta) === -1 && Object.keys(message.vetor_resposta).length >= 1">
                <!-- SETA O NOME DO USUARIO -->
                <div class="vac-reply-username">
                  <span v-html="message.vetor_resposta.username" :style="([ '', null, undefined ].indexOf(message.vetor_resposta.usuario_cor) === -1 && [ '', null, undefined ].indexOf(message.vetor_resposta.usuario_cor.fundo) === -1 ? 'color: ' + message.vetor_resposta.usuario_cor.fundo + ';' : '')"></span>
                </div>

                <!-- SETA O COMENTARIO -->
                <div class="vac-reply-content" v-html="message.vetor_resposta.mensagem"></div>
              </div>

              <!-- ARQUIVOS DA MENSAGEM -->
              <div class="reg-ate-images" v-if="[ '', null, undefined ].indexOf(message.files) === -1 && message.files.length >= 1">
                <template v-for="(arquivo, indexF) in message.files">
                  <Armazenamento-Arquivos-Icone :key="arquivo.id + '--' + indexF"
                    :cpntId='arquivo.id'
                    :cpntFileName='""'
                    :cpntFileExt='arquivo.ext'
                    :cpntFileSizeThumbnail='arquivo.size_bytes_thumbnail'
                    :cpntThumbnail='arquivo.thumbnail_b64'
                  ></Armazenamento-Arquivos-Icone>
                </template>
              </div>

              <!-- CONTEUDO DA MENSAGEM -->
              <div>
                <div>
                  <div>
                    <!-- CONECÃO COM O SUPORTE RF -->
                    <table v-if="[ '', null, undefined ].indexOf(message.suporteRF) === -1" class="conexao_SuporteRF">
                      <tr>
                        <td rowspan="3" class="icone">
                          <i class="fa fa-life-ring" title="Conexão SuporteRF"></i>
                        </td>
                        <td class="conteudo">
                          O usuário <u><span v-html="message.suporteRF.usuarioNome"></span></u> conectou com o SuporteRF com o seguinte motivo:
                        </td>
                      </tr>
                      <tr>
                        <td class="conteudo" style="padding-left: 10px;">
                          <i class="fas fa-angle-double-right"></i>
                          <span v-html="message.suporteRF.motivo"></span>
                        </td>
                      </tr>
                    </table>

                    <!-- CONTEUDO DA TELA -->
                    <span v-else target="_blank" v-html="message.content"></span>
                  </div>
                </div>
              </div>

              <!-- SETA A DATA E HORA DA MENSAGEM -->
              <div class="vac-text-timestamp">
                <!-- VERIFICA SE A MENSAGEM FOI FAVORITADA -->
                <span v-if="[ '', null, undefined ].indexOf(message.favorito) === -1" :title="'Mensagem favoritada por ' + message.favorito.usuario" style="margin-right: 2px;">
                  <svg class="fa fa-star" aria-hidden="true"></svg>
                </span>

                <!-- COLOCA A HORA DA MENSAGEM -->
                <span v-html="message.timestamp" :title="message.datahora"></span>

                <!-- COLOCA OS V DA MENSAGEM -->
                <span v-if="message.saved === true" class="reg-ate-time-line-msg-check" :class="(message.distributed === true ? 'two-check' : '') + ' ' + (message.seen === true ? 'azul' : '')">
                  <svg class="fas fa-check"></svg>
                  <svg class="fas fa-check" v-if="message.distributed === true"></svg>
                </span>
              </div>

              <div class="vac-options-container" style="width: 70px;">
                <span>
                  <!-- SETA O BACKGROUND DO CAMPO -->
                  <!-- <div class="vac-options-me"></div> -->

                  <!-- SETA O CAMPO -->
                  <div class="reg-ate-msg-acoes" @click="regAteTimeLineAbrirOpcoes(message._id)">
                    <svg class="fas fa-chevron-down"></svg>
                  </div>
                </span>
              </div>

              <!-- <div class="vac-menu-options" style="top: -132px;"> -->
              <template v-if="opcoes.indexOf(message._id) !== -1">
                <div class="vac-menu-options-bg" @click="regAteTimeLineAbrirOpcoes(message._id)"></div>
                <div class="vac-menu-options" style="top: -132px;">
                  <div class="vac-menu-list">
                    <!-- DADOS DA MENSAGEM -->
                    <div>
                      <div class="vac-menu-item" @click="regAteTimeLineOpcoesOnClick('dados', message, message._id)">Dados da mensagem</div>
                    </div>

                    <!-- RESPONDER -->
                    <div>
                      <div class="vac-menu-item" @click="regAteTimeLineOpcoesOnClick('responder', message, message._id)">Responder</div>
                    </div>

                    <!-- FAVORITOS -->
                    <div>
                      <div class="vac-menu-item" @click="regAteTimeLineOpcoesOnClick('favoritos', message, message._id)">
                        <template v-if="[ '', null, undefined ].indexOf(message.favorito) !== -1">Favoritar mensagem</template>
                        <template v-else>Desfavoritar mensagem</template>
                      </div>
                    </div>

                    <!-- EXCLUIR -->
                    <div v-if="message.senderId === $store.state.token.clu_iu">
                      <div class="vac-menu-item" @click="regAteTimeLineOpcoesOnClick('delete', message, message._id)">Apagar mensagem</div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </chat-window>

      <RF-Dialog v-if="editar === true"
      :cpntStatus='statusGeral'
      :cpntLargura='"300px"'
      :cpntTitulo="' Alterar dados do atendimento'"

      :cpntOnFecharDialog='regAteTimeLineCabecalhoAlterarEditar'>
        <template slot="conteudo">
          <div class="reg-ate-cabecalho-editar">
            <template v-for="(campo, indexC) in cabecalhoEditar">
              <RF-Componente :key="indexC"
                :data-time='time'
                :cpntTamanho='campo.tamanho'
                :cpntModelo='campo.tipo'
                :cpntStatus='campo.status'
                :cpntId='campo.id + "select"'
                :cpntClassDivField='campo.classDivField'
                :cpntNome='campo.nome'
                :cpntValue='campo.value'
                :cpntValueRef='campo.valueRef'
                :cpntOptions='campo.options'
                :cpntKeyValue='campo.keyValue'
                :cpntKeyMostra='campo.keyMostra'
                :cpntAutoComplete='campo.autocomplete'
                :cpntDisabled='campo.disabled'
                :cpntMostrar='campo.mostrar'
                :cpntMensagem='campo.mensagem'
                :cpntSelecioneNome='campo.selecioneNome'
                :cpntSelecioneValue='campo.selecioneValue'
                :cpntMensagemTipo='campo.mensagemTipo'
                :cpntAdicinarOption='campo.adicinarOption'
                :cpntMultiple='campo.multiple'
                :cpntAllRegistro='campo.allRegistro'
                :cpntExplica='campo.explica'
                :cpntConfig='campo.config'
                :cpntTabIndex='campo.tabIndex'
                :cpntMaxLength='campo.maxLength'
                :cpntOptionInicialNome='campo.optionInicialNome'
                :cpntOptionInicialValue='campo.optionInicialValue'
                :cpntSearchMinimo='campo.searchMinimo'

                :cpntOnChange='campo.onChange'
                :cpntOnBlur='campo.onBlur'
                :ref='campo.id'
              ></RF-Componente>
            </template>
          </div>
        </template>

        <template slot='rodape-right' v-if="Object.keys(cabecalhoEditarButtons).length >= 1">
          <div class="reg-ate-cabecalho-editar-rodape-right">
            <template v-for='(button, index) in cabecalhoEditarButtons'>
              <RF-Button :key="index"
                :data-time='time'

                :cpntStatus='button.status' 
                :cpntId='button.id' 
                :cpntTipo='button.tipo' 
                :cpntTexto='button.texto' 
                :cpntClass='button.class'
                :cpntMostrar='button.mostrar'
                :cpntTabIndex='button.tabIndex'

                @onClickButton='button.onClick'
              ></RF-Button>
            </template>
          </div>
        </template>
      </RF-Dialog>

      <Registro-Atendimento-Time-Line-Dados-Mensagem v-if="[ '', null, undefined ].indexOf(detalhe) === -1"
        :cpntId="detalhe"
        :cpntTamanhoRodape="0"
        :cpntOnFechar="() => { regAteTimeLineCabecalhoDadosMensagem() }"
      ></Registro-Atendimento-Time-Line-Dados-Mensagem>

      <RF-Dialog v-if="upload !== null"
      :cpntStatus='""'
      :cpntLargura='"400px"'
      :cpntTitulo='"Enviado arquivo..."'
      :cpntOnFecharDialog='regAteTimeLineIniciar'>
        <template slot="conteudo">
          <RF-Progress-Upload-Donwload :key='"upload-" + time'
            :cpntMensagem="upload.mensagem"
            :cpntTotal="upload.total"
            :cpntTransferido="upload.transferido"
            :cpntHeight="'30px'"
          ></RF-Progress-Upload-Donwload>
        </template>
      </RF-Dialog>
    </template>

    <RF-Filtro-Busca-Telas v-if="Object.keys(filtros).length >= 1 && Object.keys(filtros.field).length >= 1"
      :data-time='time'
      :cpntTime='time'
      :cpntStatus='filtros.status'
      :cpntField='filtros.field'
      :cpntTitulo="'&nbsp;Filtrar atendimentos'"

      :cpntOnRealizaBusca='() => { assuntoOr = []; roomId = ""; regAteTimeLineReiniciarTela(null) }'
      @onChangeFiltrado="regAteTimeLineFiltroOnChangeFiltrado"
      ref='filtros'
    ></RF-Filtro-Busca-Telas>
  </div>
</template>
 
<script>
  // IMPORTA DEPENDENCIA
  var moment = require('moment')
  import ChatWindow from 'vue-advanced-chat'
  import 'vue-advanced-chat/dist/vue-advanced-chat.css'

  // IMPORTA A FUNÇÃO DEPENDENTE
  var { BD_TABLE_GET, BD_TABLE_INSERT } = require('@/assets/js/BD-Functions.js')
  const FUN_RANDOM_COLOR = require('@/assets/js/Funcoes-Gerais.js').FUN_RANDOM_COLOR
 
  export default {
    components: {
      'Armazenamento-Arquivos-Icone': () => import('@/components/armazenamento-arquivos/Armazenamento-Arquivos-Icone.vue'),
      'RF-Filtro-Busca-Telas': () => import('@/components/rf-geral/busca/RF-Filtro-Busca-Telas.vue'),
      // 'RF-Filtro-Busca-Telas': () => import('@/components/rf-geral/busca/RF-Filtro-Busca-Telas.vue'),
      'RF-Progress-Upload-Donwload': () => import('@/components/rf-geral/progress/RF-Progress-Upload-Donwload.vue'),
      'Registro-Atendimento-Time-Line-Dados-Mensagem': () => import('./Registro-Atendimento-Time-Line-Dados-Mensagem.vue'),
      ChatWindow
    },
    data: function () {
      return {
        time: 1,
        qtde: 0,
        statusGeral: 'carregando',
        statusRooms: true,
        statusMessage: true,
        carregouTudoRooms: false,
        carregouTudoMessage: false,
        digitando: {},
        roomId: '',
        assuntos: [],
        assuntoOr: [],
        assuntosMostrar: [],
        messages: [],
        cores: [],
        usuariosIds: [],
        traducao: {
          ROOMS_EMPTY: 'Nenhum atendimento encontrado',
          NEW_MESSAGES: 'Nova mensagem',
          MESSAGE_DELETED: 'Esta mensagem foi apagada',
          MESSAGES_EMPTY: 'Nenhuma mensagem',
          CONVERSATION_STARTED: '',
          TYPE_MESSAGE: 'Digite uma mensagem',
          SEARCH: 'Digite sua pesquisa',
          IS_ONLINE: 'está online',
          LAST_SEEN: 'última conexão',
          IS_TYPING: 'está digitando...'
        },
        marcar: {
          entregue: [],
          lido: []
        },
        interacao: {
          entregue: [],
          lido: []
        },
        filtros: {},
        filtroBusca: '',
        detalhe: null,
        opcoes: [],
        // resquestIdEntLid: null,
        buscando: [],
        optionsClu: [],
        optionsSta: [],
        editar: false,
        // upload: JSON.parse('{"total":101987,"transferido":0,"porcentagem":0,"mensagem":"Solicitando liberação para envio dos arquivos"}'),
        upload: null,
        cabecalhoEditar: {
          clu: {
            status: '',
            tamanho: 3,
            tipo: 'select2',
            id: 'reg-ate-time-line-cab--clu--',
            nome: 'CLU',
            keyValue: 'clu',
            keyMostra: [ 'clu', ' - ', 'cliente' ],
            value: '',
            valueIni: '',
            mostrar: true,
            optionInicialNome: 'Não informada',
            searchMinimo: 20,
            onChange: this.regAteTimeLineCabecalhoOnChange
          },
          responsavel: {
            status: '',
            tamanho: 3,
            tipo: 'select2',
            id: 'reg-ate-time-line-cab--responsavel--',
            nome: 'Responsável',
            keyValue: 'id',
            keyMostra: [ 'usuario' ],
            value: '',
            valueIni: '',
            mostrar: true,
            optionInicialNome: '',
            searchMinimo: 20,
            onChange: this.regAteTimeLineCabecalhoOnChange
          },
          status: {
            status: '',
            tamanho: 3,
            tipo: 'select2',
            id: 'reg-ate-time-line-cab--status--',
            nome: 'Status',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            value: '',
            valueIni: '',
            mostrar: true,
            optionInicialNome: '',
            searchMinimo: 20,
            onChange: this.regAteTimeLineCabecalhoOnChange
          }
        },
        cabecalhoEditarButtons: {
          can: {
            id: 'reg-ate-time-line-cab--status--bt-can',
            status: '',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            tipo: 'texto',
            texto: 'Cancelar',
            onClick: this.regAteTimeLineCabecalhoAlterarEditar
          },
          env: {
            id: 'reg-ate-time-line-cab--status--bt-env',
            status: '',
            class: [ 'btn', 'btn-primary' ],
            tipo: 'texto',
            texto: 'Salvar',
            onClick: this.regAteTimeLineCabecalhoSalvarAlteracao
          }
        },
        msgAguardandoFile: {}
      }
    },
    destroyed: function () {
      // REMOVE OBSERVADOR DO EVENTO
      this.$store.state.WEB_SOCKET_OBSERVADOR('RegAtendimento-Typing', 'reg-ate-time-line', null)

      // REMOVE OBSERVADOR DO EVENTO
      this.$store.state.WEB_SOCKET_OBSERVADOR('RegAtendimento', 'reg-ate-time-line', null)

      // REMOVE OBSERVADOR DO EVENTO
      this.$store.state.WEB_SOCKET_OBSERVADOR('ArmArquivo', 'reg-ate-time-line', null)

      // REMOVE O OBSERVADOR PARA AS INTERAÇÕES
      this.$store.state.WEB_SOCKET_OBSERVADOR('RegAteInteracao', 'reg-ate-time-line', null)
    },
    mounted: function () {
      this.regAteTimeLineIniciar()
    },
    methods: {
      regAteTimeLineFechar: function () {
        if (this.$store.state.atalhos['ALT+A'].mostrar === true) {
          this.$store.commit('EXECUTE_ATALHO', 'ALT+A')
        }
      },
      regAteTimeLineIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.regAteTimeLineSetarStatusGeral('carregando')

        // REMOVE OBSERVADOR DO EVENTO
        this.$store.state.WEB_SOCKET_OBSERVADOR('RegAtendimento-Typing', 'reg-ate-time-line', this.regAteTimeLineAdicionarTyping, 'ldu', 'listenForWhisper')

        // REMOVE OBSERVADOR DO EVENTO
        this.$store.state.WEB_SOCKET_OBSERVADOR('RegAtendimento', 'reg-ate-time-line', (event) => {
          // PEGA O VALOR RECEBIDO
          var vetor = Object.values(event)[0]

          // CHAMA A FUNÇÃO PARA ATUALIZAR O STATUS DA ABA
          this.regAteTimeLineSetarStatusAba()

          // ADICIONA O ASSUNTO NA TELA
          this.regAteTimeLineAdicionarAssunto(JSON.parse(JSON.stringify([ vetor ])), true)

          // VERIFICA SE TEM ARQUIVO PARA ESSA MENSAGEM
          switch (vetor.ws_arm_arquivo) {
            case 1:
            case '1':
            case true:
            case 'true':
              // INICIA O VETOR RECEBIDO
              vetor.files = []

              // ADICONA A FUNÇÃO PARA AGUARDAR RETORNO
              this.msgAguardandoFile[vetor.id.toString()] = JSON.parse(JSON.stringify(vetor))
              break

            // CHAMA A FUNÇÃO PARA ADICIONAR A MENSAGEM NA TELA
            default:
              this.regAteTimeLineAdicionarMensagem(JSON.parse(JSON.stringify([ vetor ])), true)
              break
          }
        }, 'usu')

        // ADICIONA O OBSERVADOR
        this.$store.state.WEB_SOCKET_OBSERVADOR('ArmArquivo', 'reg-ate-time-linae', this.regAteTimeLineReceberArquivo, 'usu')

        // ADICIONA OBSERVADOR PARA PEGAR AS MENSAGENS LIDAS E ENTREGUES
        this.$store.state.WEB_SOCKET_OBSERVADOR('RegAteInteracao', 'reg-ate-time-line', this.regAteTimeLineTratarInteracao, 'usu')

        // REMOVE O CAMPO CLU CASO O CLIENTE NÃO TENHA O PACOTE SUBASE
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 7 ], null, null, null, null, null, false) !== true) {
          this.cabecalhoEditar.clu = null
        }

        // BUSCA AS CORES EXISTENTES NO BANCO DE DADOS
        BD_TABLE_GET('cores', null, null, 'GERAL').then((cores) => {
          // SETA AS CORRES RECEBIDAS
          this.cores = cores
          
          // LIMPA O VETOR DE DADOS
          this.usuariosIds = []

          // SETA O USUARIOS EXISTENTES NA CONVERSAS
          for (var indexU in this.$store.state.usuarios_reg_ate) {
            this.usuariosIds.push({ _id: Number(this.$store.state.usuarios_reg_ate[indexU].id), username: this.$store.state.usuarios_reg_ate[indexU].usuario })
          }

          // REALIZA A BUSCA DOS STATUS
          this.regAteTimeLineCabecalhoBuscarStatus().then(() => {
            // CHAMA A FUNÇÃO PARA INICIAR OS FILTROS
            this.regAteTimeLineFiltrosIniciar(() => {
              setTimeout(() => {
                this.regAteTimeLineReiniciarTela()
              }, 1000)
            })

            // SETA O STATUS DA PAGINA
            this.regAteTimeLineSetarStatusGeral('')
          })
        })
      },
      regAteTimeLineSetarStatusAba: function () {
        // MONTA O FORMULARIO PARA ENVIAR
        var formData = {}

        // ADICIONA O EVENTO RECEBIDO
        formData.evento = (document.hasFocus() === true ? 'focus' : 'blur')

        // ADICIONA O ID DO ASSUNTO ABERTO
        formData.chat = (this.$store.state.atalhos['ALT+A'].mostrar === true && [ '', null, undefined ].indexOf(this.roomId) === -1 ? this.roomId : '')

        // CHAMA A FUNÇÃO PARA SALVAR NO BANCO DE DADOS
        this.$store.commit('SET_BD_ABA_FOCUS', formData)
      },
      regAteTimeLineReiniciarTela: function (callback = null, limparFiltros = false, manterAssunto = false) {
        // LIMPA O FLAG PARA BUSCAR TODOS OS REGISTROS NOVAMENTE
        this.carregouTudoRooms = false

        // LIMPA O VETOR PARA INICIAR NOVAMENTE A BUSCA
        this.assuntos = []

        // LIMPA TODOS OS FILTROS SELECIONADOS
        if (limparFiltros === true && [ '', null, undefined ].indexOf(this.filtros) === -1 && [ '', null, undefined ].indexOf(this.filtros.field) === -1) {
          for (var indexF in this.filtros.field) {
            this.filtros.field[indexF].value = this.filtros.field[indexF].valueIni
          }
        }

        // SETA O STATUS DO ASSUNTOS
        this.statusRooms = true

        // INICIA A VARIAVEL
        var assunto = ''

        // SETA O ASSUNTO QUE ESTÁ ABERTO
        if (manterAssunto === true && [ '', null, undefined ].indexOf(this.roomId) === -1) {
          // SETA O ASSUNTO QUE DEVE SETAR APÓS CARREGAMENTO
          assunto = JSON.parse(JSON.stringify(this.roomId))

          // SETA O ASSUNTO QUE DEVE FICAR ABERTO
          this.assuntoOr = [ assunto ]
        }

        // MANDA CARREGAR OS ASSUNTOS
        this.regAteTimeLineAlterarAssunto({ options: { reset: true }, room: { roomId: null } }, () => { this.regAteTimeLineBuscarContatos(() => {
          // SETA O ASSUNTO DO CAMPO
          if ([ '', null, undefined ].indexOf(assunto) === -1) {
            this.roomId = assunto
          }

          // EXECUTA O CALLBACK SOLICITADO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }) })
      },
      regAteTimeLineFiltrosIniciar: function (callback = null) {
        // LIMPA OS FILTROS EXISTENTES
        this.filtros = {
          filtrando: false,
          status: 'carregando',
          id: 'fil-reg-ate-time-line',
          focus: '',
          field: {}
        }

        // SETA OS DADOS DO FILTRO BUSCA
        this.filtros.field.data = {
          tipo: 'data',
          nome: 'Última interação',
          value: '',
          valueIni: '',
          mostrar: true,
          dataIni: '',
          dataFim: '',
          id: this.filtros.id + '--data',
          status: ''
        }

        // SETA OS DADOS DO FILTRO BUSCA
        this.filtros.field.status = {
          id: this.filtros.id + '--status',

          tipo: 'select2-chosen',
          nome: 'Status',
          multiple: true,
          allRegistro: 'Todos',
          value: [ 't' ],
          valueIni: [ 't' ],
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          options: this.optionsSta
        }

        // SETA OS DADOS DO FILTRO BUSCA
        this.filtros.field.responsavel = {
          id: this.filtros.id + '--responsavel',

          tipo: 'select2-chosen',
          nome: 'Responsável',
          multiple: true,
          allRegistro: 'Todos',
          value: [ 't' ],
          valueIni: [ 't' ],
          keyValue: 'id',
          keyMostra: [ 'usuario' ],
          options: this.$store.state.usuarios_reg_ate
        }

        // SETA A VARIAVEL DE BUSCA
        this.filtroBusca = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      regAteTimeLineBuscarContatos: function (callback = null) {
        // VERIFICA SE CARREGOU TODAS AS INFORMAÇOES
        this.carregouTudoRooms = false

        // BUSCA OS FILTRO SELECIONADOS
        this.$refs.filtros.appCapturarFiltrosSelecionados((filtros) => {
          // INICIA O QUERYGET QUE SERÁ FEITO NA API
          var queryGet = { type: 'list', limit: { row: this.assuntos.length, qty: 200 } }
  
          // SETA OS CAMPOS QUE DEVEM SER BUSCADO
          queryGet.field = { id: null, id_contato: { j: { nome: null, empresa: null, pessoa: null, status: null } }, comentario: null, id_status: { j: { nome: null } }, responsavel_user: null, id_forma_contato: { j: { nome: null, icone: null } }, last_at: null, last_user: null }
  
          // ADCIONA O CAMPO CLU
          if ([ '', null, undefined ].indexOf(this.cabecalhoEditar.clu) === -1) {
            queryGet.field.clu = null
          }
  
          // SETA O WHERE PARA PEGAR OS REGISTROS PAÍS
          queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_reg_ate_pai', o: 'isNull' } ] }
  
          // VERIFICA SE TEM FILTRO
          if ([ '', null, undefined ].indexOf(filtros) === -1) {
            // ADICIONA O FILTRO DE RESPONSAVEL
            if ([ '', null, undefined ].indexOf(filtros.responsavel) === -1 && filtros.responsavel.indexOf('t') === -1) {
              queryGet.where.aAnd.push({ f: 'responsavel_user', o: 'in', v: Array.isArray(filtros.responsavel) === true ? filtros.responsavel.join() : filtros.responsavel })
            }
    
            // ADICIONA O FILTRO DE STATUS
            if ([ '', null, undefined ].indexOf(filtros.status) === -1 && filtros.status.indexOf('t') === -1) {
              queryGet.where.aAnd.push({ f: 'id_status', o: 'in', v: Array.isArray(filtros.status) === true ? filtros.status.join() : filtros.status })
            }
  
            if ([ '', null, undefined ].indexOf(filtros.data) === -1 && ([ '', null, undefined ].indexOf(filtros.data.ini) === -1 || [ '', null, undefined ].indexOf(filtros.data.fim) === -1)) {
              var ini = filtros.data.ini.split('/')
              queryGet.where.aAnd.push({ f: 'last_at', o: '>=', v: ini[2] + '-' + ini[1] + '-' + ini[0] + ' 00:00:00' })
  
              var fim = filtros.data.fim.split('/')
              queryGet.where.aAnd.push({ f: 'last_at', o: '<=', v: fim[2] + '-' + fim[1] + '-' + fim[0] + ' 23:59:59' })
            }
          }
  
          // VERIFICA SE FOI INFORMADO BUSCA
          if ([ '', null, undefined ].indexOf(this.filtroBusca) === -1) {
            // PEGA A BUSCA QUE DEVE SER REALIZADA
            var busca = this.filtroBusca
  
            // VERIFICA SE EXISTE ALGUM PARAMETRO NA BUSCA
            if ((busca.substring(0, 4) === 'con:' && isNaN(busca.substring(4, busca.length)) === false) === true) {
              queryGet.where.aAnd.push({ f: 'id_contato', o: 'in', v: busca.substring(4, busca.length) })
            } else if ((busca.substring(0, 1) === 'c' && isNaN(busca.substring(1, busca.length)) === false) === true && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 7, 29 ], 'and', [ 18, 53 ], 'and', null, null, false) === true) {
              queryGet.where.aAnd.push({ f: 'clu', o: '=', v: busca.substring(1, busca.length) })
            } else if ((busca.substring(0, 4) === 'clu:' && isNaN(busca.substring(4, busca.length)) === false) === true) {
              queryGet.where.aAnd.push({ f: 'clu', o: 'in', v: busca.substring(4, busca.length) })
            } else {
              queryGet.where.aAnd.push({ o: 's.ft', v: busca })
            }
          }
    
          // SETA A ORDEM QUE DEVE RETORNAR
          queryGet.order = { last_at: 'desc' }

          // SETA A INFORMAÇÃO QUE DEVE BUSCAR
          if ([ '', null, undefined ].indexOf(this.assuntoOr) === -1 && this.assuntoOr.length >= 1) {
            queryGet.where = { aOr: [ queryGet.where, { f: 'id', o: 'in', v: this.assuntoOr.join() } ] }
          }
  
          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/reg-atendimento/get/', 'GET', queryGet, (apiSuccess) => {
            this.regAteTimeLineAdicionarAssunto(apiSuccess.data, false, () => {
              setTimeout(() => {
                // SETA O FLAG DE CARREGANDO DA MENSAGEM
                if (this.statusRooms !== false) {
                  this.statusRooms = false
                }

                // VERIFICA SE CARREGOU TODAS AS INFORMAÇOES
                this.carregouTudoRooms = Number(apiSuccess.countAll) <= this.assuntos.length

                // EXECUTA A FUNÇÃO CALLBACK
                if (callback !== null && typeof callback === 'function') {
                  callback()
                }
              }, 0)
            })
          }, this.regAteTimeLineSetarStatusGeral)
        })
      },
      regAteTimeLineSetarStatusGeral: function (status) {
        if ([ '', 'carregando' ].indexOf(status) !== -1) {
          // SETA O STATUS DA TELA
          this.statusGeral = status

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        } else {
          // SETA O STATUS GERAL
          this.$store.commit('SET_APP_STATUS', status)

          // VERIFICA SE JÁ NÃO REINICIOU DE MAIS
          if (this.qtde <= 5) {
            // SOMA O VALOR DO TOTAL
            this.qtde = this.qtde + 1

            // MANDA RECOMEÇAR O PROCESSO
            this.regAteTimeLineIniciar()
          }
        }
      },
      // regAteTimeLineBuscarQtdeNaoLida: function (contatosIds, indexC = 0, registros = [], success = null) {
      regAteTimeLineBuscarQtdeNaoLida: function (assuntosIds, success = null, qtde = 300, ini = null, fim = null, retornos = []) {
        if (success === null) {
          return new Promise((success) => { this.regAteTimeLineBuscarQtdeNaoLida(assuntosIds, success, qtde, ini, fim, retornos) })
        } else {
          // SETA OS DADOS QUE SERÁ BUSCADO
          if (ini === null && fim === null) {
            ini = 0
            fim = qtde
          } else if (assuntosIds.length > (ini + qtde)) {
            ini += qtde
            fim += qtde
          } else {
            ini = null
            fim = null
          }
  
          if (ini !== null && fim !== null && assuntosIds.length >= 1) {
            // MONTA A PESQUINA NA API
            var queryGet = window.btoa(JSON.stringify(assuntosIds.slice(ini, fim)))

            // FAZ A BUSCA NA API
            this.$store.state.comunicaAPI('/reg-atendimento/nao-lido/assunto/get/', 'GET', queryGet, (apiSuccess) => {
              // JUNTA OS VALORES RECEBIDOS NO VETOR
              retornos = retornos.concat(apiSuccess.data)
  
              // FAZ A QUEBRA O VALOR RECEBIDO E CHAMA A FUNÇÃO PARA BUSCAR
              this.regAteTimeLineBuscarQtdeNaoLida(assuntosIds, success, qtde, ini, fim, retornos)
            }, this.regAteTimeLineSetarStatusGeral)
          } else {
            success(retornos)
          }
        }
      },
      regAteTimeLineTratarHoraMsg: function (datahora, formatoSaida = 'HH:mm', formatoEntrada = 'YYYY-MM-DD HH:mm:ss') {
        // CARREGA DA DATA NO VETOR
        var data = moment(datahora, formatoEntrada)

        // SETA O RETORNO QUE DEVE REALIZAR
        var retorno = ''

        // VERIFICA O FORMATO QUE DEVE UTILIZAR
        switch (formatoSaida) {
          case 'hora-data':
            // CALCULA A DIFERENÇA ENTRE AS DATAS
            var diff = this.$store.state.dadosApi._dataAtual.startOf('day').diff(moment(datahora, formatoEntrada).startOf('day'), 'days')

            // VERIFICA SE A DATA É DE ONTEM
            if (diff <= 0) {
              retorno = data.format('HH:mm')
            } else if (diff === 1) {
              retorno = 'Ontem ' + data.format('HH:mm')
            } else if (diff <= 6) {
              // SETA O VETOR DE DIAS DA SEMANHA
              var semana = [ 'Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado' ]

              // SETA O VALOR ENCONTRADO
              retorno = semana[data.day()] + ' ' + data.format('HH:mm')
            } else {
              retorno = data.format('DD/MM/YYYY')
            }
            break

          default:
            retorno = data.format(formatoSaida)
            break
        }

        // RETORNA O VALOR CALCULADO
        return retorno
      },
      regAteTimeLineAlterarAssunto: function (event = {}, callback = null) {
        if ([ '', null, undefined ].indexOf(event) === -1) {
          if ([ '', null, undefined ].indexOf(event.options) === -1 && event.options.reset === true) {
            if ([ '', null, undefined ].indexOf(event.room) === -1 && [undefined ].indexOf(event.room.roomId) === -1) {
              // SETA O NOVO ID DE ASSUNTO SELECIONADO
              this.roomId = [ '', null, undefined ].indexOf(event.room.roomId) === -1 ? Number(event.room.roomId) : ''
    
              // SETA O FLAG DE CARREGANDO DA MENSAGEM
              this.statusMessage = true

              // SETA O FLAG DE CARREGANDO DA MENSAGEM
              this.carregouTudoMessage = false

              // LIMPA A MENSAGEM ABERTA 
              this.detalhe = null

              // LIMPAR O VETOR DOS IDS QUE DEVE MARCAR
              this.marcar = { entregue: [], lido: [] }
    
              // LIMPA O VETOR DE MENSAGENS
              this.messages = []

              // LIMPA AS OPÇÕES ABERTAS
              this.opcoes = []
              
              // CHAMA A FUNÇÃO PARA BUSCAR AS MENSAGENS
              if ([ '', null, undefined ].indexOf(this.roomId) === -1 && this.buscando.indexOf('mensagens') === -1) {
                this.regAteTimeLineBuscarMensagens(callback)
              } else if (callback !== null && typeof callback === 'function') {
                callback()
              }
            }
          } else if (this.buscando.indexOf('mensagens') === -1 && [ '', null, undefined ].indexOf(event.room.roomId) === -1 && event.room.roomId === this.roomId) {
            this.regAteTimeLineBuscarMensagens(callback)
          } else if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }
      },
      regAteTimeLineBuscarMensagens: function (callback = null) {
        // ADICIONA QUE ESTÁ BUSCANDO AS MENSAGENS
        this.buscando.push('mensagens')

        // INICIA O QUERYGET QUE SERÁ FEITO NA API
        var queryGet = { type: 'list', limit: { row: this.messages.length, qty: 30 } }

        // SETA O WHERE PARA PEGAR OS REGISTROS PAÍS
        queryGet.where = { aAnd: [ { f: 'id_reg_ate_pai', o: '=', v: this.roomId } ] }

        // SETA A ORDEM QUE DEVE RETORNAR
        queryGet.order = { last_at: 'desc' }

        // FAZ A BUSCA NA API
        this.$store.state.comunicaAPI('/reg-atendimento/get/', 'GET', queryGet, (apiSuccess) => {
          // ORDENA O VETOR DE DIAS
          apiSuccess.data = apiSuccess.data.sort((a, b) => { return Number(a.id) < Number(b.id) ? -1 : Number(a.id) > Number(b.id) ? 1 : 0 })

          // CHAMA A FUNÇÃO PARA ADICIONAR AS MENSAGENS
          this.regAteTimeLineAdicionarMensagem(apiSuccess.data, false, () => {
            setTimeout(() => {
              // SETA O FLAG DE CARREGANDO DA MENSAGEM
              if (this.statusMessage !== false) {
                this.statusMessage = false
              }

              // VERIFICA SE CARREGOU TODAS AS INFORMAÇOES
              this.carregouTudoMessage = Number(apiSuccess.countAll) <= this.messages.length

              // REMOVER VALORES DUPLICADOS
              this.buscando = this.buscando.filter(item => item !== 'mensagens')

              // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
              if (callback !== null && typeof callback === 'function') {
                callback()
              }
            }, 0)
          })
        }, this.regAteTimeLineSetarStatusGeral)
      },
      regAteTimeLineBuscarArquivos: function (ids, success = null, qtde = 300, ini = null, fim = null, retornos = []) {
        if (success === null) {
          return new Promise((success) => { this.regAteTimeLineBuscarArquivos(ids, success, qtde, ini, fim, retornos) })
        } else {
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 30 ], null, null, null, null, null, false) === true) {
            // SETA OS DADOS QUE SERÁ BUSCADO
            if (ini === null && fim === null) {
              ini = 0
              fim = qtde
            } else if (ids.length > (ini + qtde)) {
              ini += qtde
              fim += qtde
            } else {
              ini = null
              fim = null
            }
    
            if (ini !== null && fim !== null && ids.length >= 1) {
              // INICIA O QUERYGET
              var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }
    
              // SETA OS FILDS QUE DESEJA 
              queryGet.field = { id: null, id_reg_atendimento: null, filename: { a: 'name' }, ext: null, size_bytes_total: null, size_bytes_thumbnail: null }
              
              // SETA O WHERE
              queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }
    
              // MONTA A PESQUINA NA API
              queryGet.where.aAnd.push({ f: 'id_reg_atendimento', o: 'in', v: ids.slice(ini, fim).join() })
    
              // FAZ A BUSCA NA API
              this.$store.state.comunicaAPI('/arm-arquivo/get/', 'GET', queryGet, (apiSuccess) => {
                // JUNTA OS VALORES RECEBIDOS NO VETOR
                retornos = retornos.concat(apiSuccess.data)
    
                // FAZ A QUEBRA O VALOR RECEBIDO E CHAMA A FUNÇÃO PARA BUSCAR
                this.regAteTimeLineBuscarArquivos(ids, success, qtde, ini, fim, retornos)
              }, this.regAteTimeLineSetarStatusGeral)
            } else {
              // INICIA O VETOR PARA ADICONAR O IDS
              var vetor = []
  
              // TRATA CADA ARQUIVO
              for (var indexF in retornos) {
                if ([ 'ogg', 'mp3' ].indexOf(retornos[indexF].ext) !== -1 || ([ '', null, undefined ].indexOf(retornos[indexF].size_bytes_thumbnail) === -1 && Number(retornos[indexF].size_bytes_thumbnail) > 0)) {
                  vetor.push({ id: retornos[indexF].id, tipo: [ ([ 'ogg', 'mp3' ].indexOf(retornos[indexF].ext) === -1 ? 'thumbnail_b64' : 'link_download') ] })
                }
  
                // INICIA A VARIAVEL PARA BLOQUEAR BUSCA
                retornos[indexF].thumbnail_b64 = ''
              }
  
              // CHAMA A FUNÇÃO PARA FINALIZAR SE NÃO TIVER THUMBNAIL
              this.regAteTimeLineBuscarConteudoArquivos(vetor).then((vetor) => {
                // ADICIONA AS INFORMAÇOES RECEBIDAS
                for (var key in vetor) {
                  // CONVERTE A CHAVE QUANDO É UM ARQUIVO COM LINK DE DOWNLOAD
                  if ([ '', null, undefined ].indexOf(vetor[key].thumbnail_b64) !== -1 && [ '', null, undefined ].indexOf(vetor[key].link_download) === -1) {
                    vetor[key].thumbnail_b64 = vetor[key].link_download
                  }

                  // PEGA O INDEX QUE DEVE ADICIONAR
                  var index = retornos.findIndex(item => item.id === vetor[key].id)
  
                  // JUNTA OS VALORES
                  if (index !== -1) {
                    retornos[index] = Object.assign(retornos[index], vetor[key])
                  }
                }
                
                // RETORNA O VALOR MONTADO
                success(retornos)
              })
            }
          } else {
            success([])
          }
        }
      },
      regAteTimeLineBuscarConteudoArquivos: function (vetor, success = null, qtde = 300, ini = null, fim = null, retornos = []) {
        if (success === null) {
          return new Promise((success) => { this.regAteTimeLineBuscarConteudoArquivos(vetor, success, qtde, ini, fim, retornos) })
        } else {
          // SETA OS DADOS QUE SERÁ BUSCADO
          if (ini === null && fim === null) {
            ini = 0
            fim = qtde
          } else if (vetor.length > (ini + qtde)) {
            ini += qtde
            fim += qtde
          } else {
            ini = null
            fim = null
          }

          if (ini !== null && fim !== null && vetor.length >= 1) {
            // PEGA OS IDS QUE DEVE BUSCAR
            var busca = vetor.slice(ini, fim)

            // INICIA O QUERYGET
            var queryGet = { lot: busca }

            // FAZ A BUSCA NA API
            this.$store.state.comunicaAPI('/arm-arquivo/arquivo/get/', 'GET', queryGet, (apiSuccess) => {
              // ADICIONA OS VALORES NO VETOR
              for (var index in apiSuccess.lot) {
                switch (apiSuccess.lot[index].code) {
                  case '200':
                    retornos.push(apiSuccess.lot[index].data)
                    break
                  
                  default:
                    this.$store.state.msgWarn('API [' + apiSuccess.lot[index].code + ']: ' + apiSuccess.lot[index].message, 'danger')
                    break
                }
              }

              // FAZ A QUEBRA O VALOR RECEBIDO E CHAMA A FUNÇÃO PARA BUSCAR
              this.regAteTimeLineBuscarConteudoArquivos(vetor, success, qtde, ini, fim, retornos)
            }, this.regAteTimeLineSetarStatusGeral)
          } else {
            success(retornos)
          }
        }
      },
      regAteTimeLineAdicionarTyping: function (event) {
        if ([ '', null, undefined ].indexOf(event.data) === -1 && [ '', null, undefined ].indexOf(event.data.assunto) === -1) {
          // PEGA A CHAVE INDEX DO ASSUNTO
          var indexA = this.assuntos.findIndex(item => Number(item.id) === Number(event.data.assunto))

          // VERIFICA SE FOI ENCONTRADO VALOR PARA O VETOR
          if (indexA !== -1) {
            // PEGA O ID DO USUARIO
            var usuarioId = Number(event.data.usuario)

            // ADICIONA O ID DO USUARIO QUE ESTÁ DIGITANDO
            this.assuntos[indexA].typingUsers = this.assuntos[indexA].typingUsers.concat([ usuarioId ])

            // LIMPA A VERIFICAÇÃO SE EXISTIR
            clearTimeout(this.digitando[usuarioId])

            // CHAMA A FUNÇÃO PARA REMOVER O DIGITANDO
            this.digitando[usuarioId] = setTimeout(() => { this.regAteTimeLineRemoverTyping(indexA, usuarioId) }, 1000) 
          }
        }
      },
      regAteTimeLineRemoverTyping: function (indexA, usuarioId) {
        // PEGA OS USUARIOS QUE ESTÃO DIGITANDO
        var typing = JSON.parse(JSON.stringify(this.assuntos[indexA].typingUsers))

        // REMOVE O USUARIO SOLICITADO
        this.assuntos[indexA].typingUsers = typing.filter(item => item !== usuarioId)

        // LIMPA A VERIFICAÇÃO SE EXISTIR
        clearTimeout(this.digitando[usuarioId])
      },
      regAteTimeLineEnviarTyping: function (event) {
        if ([ '', null, undefined ].indexOf(event.roomId) === -1 && [ '', null, undefined ].indexOf(event.message) === -1) {
          this.$store.state.WEB_SOCKET_ENVIA_MSG('RegAtendimento-Typing', {
            channel: 'Clu.' + this.$store.state.token.clu,
            event: 'RegAtendimento-Typing',
            data: {
              assunto: event.roomId,
              usuario: this.$store.state.usuario.id_usu
            }
          })
        }
      },
      regAteTimeLineEnviarMensagem: function (event) {
        // this.regAteTimeLineEnviarArquivo(385, [ event.file ])
        // MONTA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = { id_reg_ate_pai: event.roomId, comentario: event.content }
        
        // VERIFICA SE ESTÁ, SENDO PREENCHIDO UMA RESPOSTA A ALGUMA MENSAGEM
        if ([ '', null, undefined ].indexOf(event.replyMessage) === -1 && [ '', null, undefined ].indexOf(event.replyMessage) === -1) {
          formData.id_reg_ate_citar = event.replyMessage._id
        }

        // COLOCA O FLAG, PARA VERIFICAR SE TEM ARQUIVO OU NÃO NA MENSAGEM
        formData.ws_arm_arquivo = [ '', null, undefined ].indexOf(event.file) === -1 ? '1' : '0'

        // CONVERTE O REGISTRO EM LOT
        formData = { lot: [ formData ] }

        // FAZ A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI('/reg-atendimento', 'POST', formData, (apiSuccess) => {
          // PEGA OS VALORES RECEBIDOS
          var retorno = apiSuccess.lot[0]

          // VERIFICA SE DEU ALGUM ERRO PARA INSERIR
          if (retorno.code !== '200') {
            this.$store.state.msgWarn('API [' + retorno.code + ']: ' + retorno.message, 'danger')
          }

          // VERIFICA SE O WS FOI ENVIADO
          if (retorno.code === '200' && ([ '', null, undefined ].indexOf(retorno.ws) !== -1 || retorno.ws.code !== '200')) {
            // INICIA A MENSAGEM
            var erroWS = { cod: '500', loc: 'WS', err: '' }

            // SETA O CODIGO RECEBIDO
            if ([ '', null, undefined ].indexOf(retorno.ws) === -1 && [ '', null, undefined ].indexOf(retorno.ws.code) !== -1) {
              erroWS.cod += retorno.ws.code
            }

            // SETA A MENSAGEM RECEBIDA
            if ([ '', null, undefined ].indexOf(retorno.ws) === -1 && [ '', null, undefined ].indexOf(retorno.ws.message) === -1) {
              erroWS.err += retorno.ws.message
            } else {
              erroWS.err += 'OPS! Não foi possível enviar a mensagem neste momento aos outros usuários. Por favor entre em contato com nosso suporte.'
            }

            // SETA O ERRO NA MASCARA
            this.regAteTimeLineSetarStatusGeral(erroWS)
          }

          // CHAMA A FUNÇÃO PARA ENVIAR OS ARQUIVOS
          if (retorno.code === '200' && [ '', null, undefined ].indexOf(event.file) === -1) {
            this.regAteTimeLineEnviarArquivo(retorno.ref.id, [ event.file ])
          }
        }, this.regAteTimeLineSetarStatusGeral)
      },
      regAteTimeLineEnviarArquivo: function (id, files = null) {
        if ([ '', null, undefined ].indexOf(id) === -1 && [ '', null, undefined ].indexOf(files) === -1) {
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 30 ], null, null, null, null, null, false) === true) {
            // PEGA OS ARQUIVOS
            var vetor = []

            // CONVERTE OS ARQUIVOS RECEBIDOS EM FILES
            for (var indexF in files) {
              if (files[indexF].audio === true) {
                vetor.push(new File([ files[indexF].blob ], 'audio.ogg', { type: files[indexF].type }))
              } else {
                vetor.push(new File([ files[indexF].blob ], (files[indexF].name + '.' + files[indexF].extension), { type: files[indexF].type }))
              }
            }

            // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
            const ARMAZENAR_ARQUIVO_S3 = require('@/assets/js/Armazenar-Arquivos.js').ARMAZENAR_ARQUIVO_S3
  
            // CHAMA A FUNÇÃO PARA ENVIAR O ARQUIVO
            ARMAZENAR_ARQUIVO_S3(vetor, 53, Number(id), this.regAteTimeLineRodapeAnexarProgress).then(() => {
              // SETA OS DADOS RECEBIDOS DA PARCIAL
              this.upload = null

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }).catch(this.regAteTimeLineSetarStatusGeral)
          }
        }
      },
      regAteTimeLineRodapeAnexarProgress: function (mensagem, retornos) {
        // INICIA A VARIAVEL QUE VAI RECEBER OS DADOS
        var dados = { total: 0, transferido: 0 }

        // PEGA OS DADOS RECEBIDOS
        if ([ '', null, undefined ].indexOf(retornos.result) === -1) {
          dados = retornos.result
        }

        // ALTERA A MENSAGEM DO CAMPO
        dados.mensagem = mensagem

        // SETA OS DADOS RECEBIDOS DA PARCIAL
        this.upload = dados

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteTimeLineAdicionarAssunto: function (vetor, ws = false, callback = null) {
        // INICIA A VARIAVEL DE ASSUNTOS
        var assuntos = []

        // FAZ A VERIFICAÇÃO SE DEVE PROCESSAR
        if (ws === false || (ws === true && [ '', null, undefined ].indexOf(vetor[0].id_reg_ate_pai) !== -1)) {
          // INICIA A VARIAVEL PARA VERIFICAR A QUANTIDADE NÃO LIDA DE MENSAGENS
          var assuntosIds = []

          // INICIA A VARIAVEL COR
          var cor = ''         
  
          // ADICIONA TODOS OS REGISTROS ENCONTRADOS
          for (var indexA in vetor) {
            if ([ '', null, undefined ].indexOf(vetor[indexA].id_reg_ate_pai) !== -1) {
              // PEGA O ASSUNTO RECEBIDO
              var assunto = vetor[indexA]
    
              // ADICIONA O ID DO CONTATO SOLICITADO
              assuntosIds.push(Number(assunto.id))
    
              // VERIFICA SE É UMA CONEXÃO DO SUPORTE RF
              if (assunto.comentario.indexOf('CONECTAR_SUPORTE_RF') !== -1) {
                // CONVERTE EM VETOR O VALOR RECEBIDO
                assunto.comentario = JSON.parse(assunto.comentario)
    
                // PEGA O MOTIVO DA CONEXÃO
                assunto.comentario = assunto.comentario.motivo
              }
  
              // PEGA OS DADOS DO USUARIO
              var usuario = this.$store.state.usuarios.filter(item => Number(item.id) === Number(assunto.responsavel_user))
  
              // INICIA A VARIAVEL
              assunto.responsavel = { inicial: '' }
  
              // VERIFICA SE ENCONTROU O USUARIO
              if (usuario.length >= 1) {
                // SETA O RESPONSAVEL PELO ASSUNTO
                assunto.responsavel = usuario[0]
  
                // SETA A INICIAL DO RESPONSAVEL
                assunto.responsavel.inicial = assunto.responsavel.usuario.trim().substring(0, 1) + '' + assunto.responsavel.id
                assunto.responsavel.inicial = assunto.responsavel.inicial.toUpperCase()
              }
  
              // CARREGA A DATA E HORA DA MENSAGEM
              assunto.timestamp = this.regAteTimeLineTratarHoraMsg(assunto.last_at, 'hora-data')
  
              // SETA A DATA E HORA DA ULTIMA ATUALIZAÇÃO
              assunto.datahora = this.regAteTimeLineTratarHoraMsg(assunto.last_at, 'DD/MM/YYYY HH:mm:ss')

              // SETA O TIMESTAMP DA ULTIMA MENSAGEM PARA ORDENAR CORRETAMENTE
              assunto.lastMessage = { date: Number(moment(vetor[0].last_at, 'YYYY-MM-DD HH:mm:ss').format('x')) },
    
              // SETA A COR DO CONTATO
              assunto.cor_res = this.cores.filter(item => item.chave === assunto.responsavel_user)
      
              // VERIFICA SE FOI ENCONTRADO ALGUMA REGISTRO
              assunto.cor_res = assunto.cor_res.length >= 1 ? assunto.cor_res[0] : null
    
              // SE NÃO EXISTIR COR, GERA UMA NOVA COR PARA ESTE REGISTRO
              if (assunto.cor_res === null) {
                // GERA AS NOVAS CORRES PARA OS CAMPOS
                cor = FUN_RANDOM_COLOR()
    
                // SETA O VALOR RECEBIDO
                assunto.cor_res = { chave: assunto.responsavel_user, borda: cor[0], fundo: cor[1], letra: cor[2] }
                
                // ADICIONA O VALOR GERADO NO VETOR
                this.cores.push(assunto.cor_res)
    
                // SALVA NO BANCO DE DADOS PARA NÃO PRECISAR GERAR NOVAMENTE
                BD_TABLE_INSERT('cores', assunto.cor_res, 'GERAL')
              }
  
              // SETA A COR DO CONTATO
              assunto.cor_sta = this.cores.filter(item => item.chave === assunto.id_status)
      
              // VERIFICA SE FOI ENCONTRADO ALGUMA REGISTRO
              assunto.cor_sta = assunto.cor_sta.length >= 1 ? assunto.cor_sta[0] : null
    
              // SE NÃO EXISTIR COR, GERA UMA NOVA COR PARA ESTE REGISTRO
              if (assunto.cor_sta === null) {
                // GERA AS NOVAS CORRES PARA OS CAMPOS
                cor = FUN_RANDOM_COLOR()
    
                // SETA O VALOR RECEBIDO
                assunto.cor_sta = { chave: assunto.id_status, borda: cor[0], fundo: cor[1], letra: cor[2] }
                
                // ADICIONA O VALOR GERADO NO VETOR
                this.cores.push(assunto.cor_sta)
    
                // SALVA NO BANCO DE DADOS PARA NÃO PRECISAR GERAR NOVAMENTE
                BD_TABLE_INSERT('cores', assunto.cor_sta, 'GERAL')
              }

              if ([ '', null, undefined ].indexOf(assunto.clu) === -1) {
                // SETA A COR DO CONTATO
                assunto.cor_clu = this.cores.filter(item => item.chave === assunto.clu)
        
                // VERIFICA SE FOI ENCONTRADO ALGUMA REGISTRO
                assunto.cor_clu = assunto.cor_clu.length >= 1 ? assunto.cor_clu[0] : null
      
                // SE NÃO EXISTIR COR, GERA UMA NOVA COR PARA ESTE REGISTRO
                if (assunto.cor_clu === null) {
                  // GERA AS NOVAS CORRES PARA OS CAMPOS
                  cor = FUN_RANDOM_COLOR()
      
                  // SETA O VALOR RECEBIDO
                  assunto.cor_clu = { chave: assunto.clu, borda: cor[0], fundo: cor[1], letra: cor[2] }
                  
                  // ADICIONA O VALOR GERADO NO VETOR
                  this.cores.push(assunto.cor_clu)
      
                  // SALVA NO BANCO DE DADOS PARA NÃO PRECISAR GERAR NOVAMENTE
                  BD_TABLE_INSERT('cores', assunto.cor_clu, 'GERAL')
                }

                // ALTERA A TRANSPARENCIA DO FUNDO
                assunto.cor_clu.fundo = assunto.cor_clu.fundo.replace(',1', ',0.6')
              }
  
              // SETA A INICIAL DO RESPONSAVEL
              assunto.id_status_nome_inicial = assunto.id_status_nome.trim().substring(0, 1)
              assunto.id_status_nome_inicial = assunto.id_status_nome_inicial.toUpperCase()
      
              // INICIA O NUMERO DE MENSAGENS NÃO LIDAS
              assunto.unreadCount = 0
  
              // ADICIONA AS CHAVES FALTANTES
              assunto = Object.assign({ roomId: Number(assunto.id), roomName: assunto.id_contato_nome, users: this.usuariosIds, typingUsers: [] }, assunto)
    
              // ADCIIONA O VALOR NO VETOR
              assuntos.push(assunto)
  
              // VERIFICA SE FOI RECEBIDO PELO WEBSOCKET
              if (ws === true) {
                // PEGA O NUMERO DA LINHA DO REGISTRO
                var indexR = this.assuntos.findIndex(item => item.roomId === assunto.roomId)

                // VERIFICA SE O REGISTRO FOI ENCONTRADO
                if (indexR === -1) {
                  this.assuntos = [ assunto ].concat(JSON.parse(JSON.stringify(this.assuntos)))
                } else {
                  this.$set(this.assuntos, indexR, assunto)
                }
              }
            }
          }
  
          // REMOVER VALORES DUPLICADOS
          assuntosIds = assuntosIds.filter((v, i, a) => a.indexOf(v) === i)

          // VERIFICA SE FOI RECEBIDO VIA WS
          if (ws === false) {
            // CHAMA A FUNÇÃO PARA BUSCAR A QUANTIDADE NÃO LIDA DE CADA ITEM
            this.regAteTimeLineBuscarQtdeNaoLida(assuntosIds).then((vetor) => {
              // SETA OS VALORES RECEBIDOS PARA CADA ASSUNTO
              for (var indexV in vetor) {
                // PROCURA O ASSUNTO QUE TEM MENSAGEM NÃO LIDA
                var indexR = assuntos.findIndex(item => item.roomId === Number(vetor[indexV].id))
    
                // SETA A QUANTIDADE NÃO LIDA
                if (indexR !== -1) {
                  assuntos[indexR].unreadCount = Number(vetor[indexV].nLido)
                }
              }
    
              // SETA OS ASSUNTOS GERADOS
              this.assuntos = assuntos

              // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
              if (callback !== null && typeof callback === 'function') {
                callback()
              }
            })
          } else if ([ '', null, undefined ].indexOf(this.filtroBusca) === -1 || this.filtros.filtrando === true) {
            // PEGA A BUSCA QUE DEVE SER REALIZADA
            var busca = this.filtroBusca

            // PEGA APENAS O ID PESQUISADO
            busca = (busca.substring(0, 4) === 'con:' && isNaN(busca.substring(4, busca.length)) === false) === true ? busca.substring(4, busca.length) : ''

            // PEGA TODOS OS ASSUNTOS
            assuntos = JSON.parse(JSON.stringify(this.assuntos))

            // REMOVE OS DADOS PESQUISADOS
            assuntos = assuntos.filter(item => {
              if (this.assuntoOr.indexOf(item.roomId) === -1) {
                // VERIFICA SE TEM ALGUAM BUSCA DE CONTATO NO INPUT
                if ([ '', null, undefined ].indexOf(busca) === -1 && busca !== item.id_contato) {
                  return false
                }
  
                // VERIFICA SE O RESPONSAVEL DO ASSUNTO É O MESMO DO FILTRO
                if ([ '', null, undefined ].indexOf(this.filtros.field.responsavel.value) === -1 && this.filtros.field.responsavel.value.indexOf(item.responsavel_user.toString()) === -1) {
                  return false
                }
  
                // VERIFICA SE O RESPONSAVEL DO ASSUNTO É O MESMO DO FILTRO
                if ([ '', null, undefined ].indexOf(this.filtros.field.status.value) === -1 && this.filtros.field.status.value.indexOf(item.id_status.toString()) === -1) {
                  return false
                }
              }

              // ITEM VALIDO, PODE APRESENTAR
              return true
            })

            // SETA OS ASSUNTOS GERADOS
            this.assuntos = assuntos
          }
        } else {
          // PROCURA O ASSUNTO QUE TEM MENSAGEM NÃO LIDA
          var indexT = this.assuntos.findIndex(item => item.roomId === Number(vetor[0].id_reg_ate_pai))

          // VERIFICA SE O REGISTRO FOI ENCONTRADO
          if (indexT !== -1) {
            // PEGA TODOS OS ASSUNTOS
            assuntos = JSON.parse(JSON.stringify(this.assuntos))
  
            // SETA OS NOVOS VALORES
            assuntos[indexT] = Object.assign(assuntos[indexT], {
              // CARREGA A DATA E HORA DA MENSAGEM
              timestamp: this.regAteTimeLineTratarHoraMsg(vetor[0].last_at, 'hora-data'),

              // SETA O TIMESTAMP DA ULTIMA MENSAGEM PARA ORDENAR CORRETAMENTE
              lastMessage: { date: Number(moment(vetor[0].last_at, 'YYYY-MM-DD HH:mm:ss').format('x')) },
  
              // SETA A DATA E HORA DA ULTIMA ATUALIZAÇÃO
              datahora: this.regAteTimeLineTratarHoraMsg(vetor[0].last_at, 'DD/MM/YYYY HH:mm:ss')
            })
  
            // SETA OS ASSUNTOS GERADOS
            this.assuntos = assuntos
          }

          // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }
      },
      regAteTimeLineAdicionarMensagem: function (vetor, ws = false, callback = null) {
        if ([ '', null, undefined ].indexOf(this.roomId) === -1) {
          // PEGA TODOS OS IDS DAS MENSAGENS
          var ids = []
  
          // INICIA O VETOR QUE VAI RECEBER AS MENSAGENS
          var messages = []
        }
  
        // TRATA CADA MENSAGEM RECEBIDA
        for (var indexM in vetor) {
          // PEGA A CHAVE PARA VETOR
          var chave = vetor[indexM].id

          // VERIFICA SE É DO ASSUNTO QUE ESTÁ ABERTO
          if (this.roomId === Number(vetor[indexM].id_reg_ate_pai)) {
            // ADICIONA O ID NO VETOR PARA BUSCAR OS DADOS
            ids.push(vetor[indexM].id)
  
            // INICIA O VETOR DA MENSAGEM
            var mensagem = {}
  
            // SETA O ID DA MENSAGEM
            mensagem._id = Number(chave)

            // VERIFICA SE É UMA CONEXÃO DO SUPORTE RF
            mensagem.content = ''
            if ([ '', null, undefined ].indexOf(vetor[indexM].comentario) === -1) {
              if (vetor[indexM].comentario.indexOf('CONECTAR_SUPORTE_RF') !== -1) {
                mensagem.suporteRF = JSON.parse(vetor[indexM].comentario)
              } else {
                mensagem.content = vetor[indexM].comentario
              }
            }
  
            // SETA SE A MENSAGEM PODE TER OU NÃO REAÇÕES
            mensagem.disable_reactions = true
  
            // SETA AS MENSAGENS COMO SALVA, NÃO ENTREGUE A TODOS E NÃO LIDA A TODOS
            mensagem.saved = true
            mensagem.distributed = false
            mensagem.seen = false

            if ([ 89 ].indexOf(mensagem._id) !== -1) {
              mensagem.saved = false
            } else if ([ 90, 91 ].indexOf(mensagem._id) !== -1) {
              vetor[indexM].entregue_todos = '1'
            } else if ([ 92, 93 ].indexOf(mensagem._id) !== -1) {
              vetor[indexM].entregue_todos = '1'
              vetor[indexM].lido_todos = '1'
            }
            
            // VERIFICA SE FOI ENTREGUE A TODOS
            if (vetor[indexM].entregue_todos === '1' || vetor[indexM].status !== '1') {
              mensagem.distributed = true
              this.interacao.entregue.push(chave)
            }
  
            // VERIFICA SE FOI LIDO POR TODOS
            if (vetor[indexM].lido_todos === '1' || vetor[indexM].status !== '1') {
              mensagem.seen = true
              this.interacao.lido.push(chave)
            }
  
            // PEGA A DATA E HORA DA MENSAGEM
            mensagem.timestamp = this.regAteTimeLineTratarHoraMsg(vetor[indexM].last_at)

            // SETA A DATA E HORA DA ULTIMA ATUALIZAÇÃO
            mensagem.datahora = this.regAteTimeLineTratarHoraMsg(vetor[indexM].last_at, 'DD/MM/YYYY HH:mm:ss')
  
            // SETA OS DADOS INICIAL DO USUARIO
            mensagem.senderId = 0
            mensagem.username = 'ERRO [500]: USUARIO NÃO ENCONTRADO'
  
            // PEGA OS DADOS DO USUARIO
            var usuario = this.$store.state.usuarios.filter(item => item.id === vetor[indexM].last_user)
  
            // SETA O ID DA MENSAGEM
            if (usuario.length >= 1) {
              mensagem.senderId = Number(usuario[0].id)
              mensagem.username = usuario[0].usuario

              // SETA A COR DO CONTATO
              mensagem.usuario_cor = this.cores.filter(item => item.chave === usuario[0].id)
      
              // VERIFICA SE FOI ENCONTRADO ALGUMA REGISTRO
              mensagem.usuario_cor = mensagem.usuario_cor.length >= 1 ? mensagem.usuario_cor[0] : null
    
              // SE NÃO EXISTIR COR, GERA UMA NOVA COR PARA ESTE REGISTRO
              if (mensagem.usuario_cor === null) {
                // GERA AS NOVAS CORRES PARA OS CAMPOS
                var cor = FUN_RANDOM_COLOR()
    
                // SETA O VALOR RECEBIDO
                mensagem.usuario_cor = { chave: mensagem.responsavel_user, borda: cor[0], fundo: cor[1], letra: cor[2] }
                
                // ADICIONA O VALOR GERADO NO VETOR
                this.cores.push(mensagem.usuario_cor)
    
                // SALVA NO BANCO DE DADOS PARA NÃO PRECISAR GERAR NOVAMENTE
                BD_TABLE_INSERT('cores', mensagem.usuario_cor, 'GERAL')
              }
            }

            // VERIFICA SE A MENSAGEM ESTÁ EXCLUIDA
            mensagem.excluido = vetor[indexM].status !== '1'

            // SETA SE A MENSAGEM FOI FAVORITADA OU NÃO
            mensagem.favorito = ''
            if ([ '', null, undefined ].indexOf(vetor[indexM].id_usu_favorito) === -1) {
              mensagem.favorito = this.$store.state.usuarios.filter(item => item.id === vetor[indexM].id_usu_favorito)[0]
            }

            // VERIFICA SE DEVE OU NÃO MARCAR A MENSAGEM
            if (vetor[indexM].status === '1' && (ws === false || (ws === true && mensagem.senderId !== this.$store.state.token.clu_iu))) {
              // VERIFICA SE O REGISTRO JÁ FOI ENTREGUE
              if (this.interacao.entregue.indexOf(chave) === -1) {
                this.marcar.entregue.push(chave)
              }
  
              // VERIFICA SE O REGISTRO JÁ FOI LIDO
              if (this.interacao.lido.indexOf(chave) === -1) {
                this.marcar.lido.push(chave)
              }
            }

            // SETA SE TEM QUE BUSCAR UMA MENSAGEM CITADA
            mensagem.id_reg_ate_citar = Number(vetor[indexM].id_reg_ate_citar)

            // INICIA O VALOR DO CAMPO DE RESPOSTA
            mensagem.vetor_resposta = {}

            // VERIFICA SE O VALOR FOI INICIADO
            mensagem.files = []
            if ([ '', null, undefined ].indexOf(vetor[indexM].files) === -1) {
              mensagem.files = vetor[indexM].files
            }

            // SETA AS CHAVES COMPLEMENTARES
            mensagem = Object.assign({ date: this.regAteTimeLineTratarHoraMsg(vetor[indexM].last_at, 'DD/MM/YYYY'), system: false, disable_actions: false }, mensagem)
  
            // ADICIONA A MENSAGEM AO VETOR MASTER
            messages.push(mensagem)
  
            // VERIFICA SE FOI RECEBIDO PELO WEBSOCKET
            if (ws === true) {
              // VERIFICA SE O VALOR JÁ EXISTE NO VETOR
              var indexI = this.messages.findIndex(item => item._id === mensagem._id)

              // VERIFICA SE O REGISTRO JÁ EXISTE NO VETOR
              if (indexI === -1) {
                this.$set(this.messages, this.messages.length, mensagem)
              } else {
                // PEGA AS MENSAGENS DO VETOR
                var _messages = JSON.parse(JSON.stringify(this.messages))
  
                // SETA OS NOVOS VALORES
                _messages[indexI] = Object.assign(_messages[indexI], mensagem)

                // SETA AS MENSAGENS TRABALHADAS
                this.messages = _messages
              }
            }
          } else if (vetor[indexM].status === '1' && this.interacao.entregue.indexOf(chave) === -1) {
            this.marcar.entregue.push(chave)
          } else if (vetor[indexM].status !== '1') {
            this.interacao.entregue.push(chave)
            this.interacao.lido.push(chave)
          }

          // ADICIONA UM NA MENSAGEM NÃO LIDA
          if (ws === true && vetor[indexM].notificar === '1' && Number(vetor[indexM].last_user) !== Number(this.$store.state.token.clu_iu)) {
            setTimeout(() => { this.regAteTimeLineAdicionarRemoverNaoLidos(vetor[indexM].id_reg_ate_pai, 1) }, 1000)
          }
        }

        // CHAMA A FUNÇÃO PARA VERIFICAR SE TEM ARQUIVOS
        if ([ '', null, undefined ].indexOf(this.roomId) === -1 && ws === false) {
          this.regAteTimeLineBuscarArquivos(ids).then((arquivos) => {
            for (var indexA in arquivos) {
              // PEGA O NUMERO DA LINHA QUE TEM ARQUIVO
              var index = messages.findIndex(item => item._id === Number(arquivos[indexA].id_reg_atendimento))

              // VERIFICA SE O REGISTRO FOI ENCONTRADO
              if (index !== -1) {
                messages[index].files.push(arquivos[indexA])
              }
            }

            // SETA OS ASSUNTOS GERADOS
            // this.messages = messages.concat(this.messages)

            // CHAMA A FUNÇÃO PARA SETAR AS RESPOSTA DE UMA MENSAGEM
            this.regAteTimeLineSetarRespostasMensagen(callback, messages.concat(this.messages))
          })
        } else {
          this.regAteTimeLineSetarRespostasMensagen(callback)
        }

        // CHAMA A FUNÇÃO PARA MARCAR ENTREGUE LIDO DA MESNAGEM
        this.regAteTimeLineMarcarEntregueLido(ws)
      },
      regAteTimeLineCriarAssunto: function () {
        // SETA OS PARAMETROS PARA INICIAR
        var params = { tipo: 'REGISTRO_ATENDIMENTO_INICIAR' }

        // SETA A FUNÇÃO CALLBACK
        // eslint-disable-next-line
        params.callback = (atualizar, id_contato = null, id_reg_ate_pai = null) => {
          if (atualizar === true) {
            setTimeout(() => { this.regAteTimeLineAlterarAssunto({ options: { reset: true }, room: { roomId: id_reg_ate_pai } }) }, 500)
          }
        }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      regAteTimeLineTratarInteracao: function (event) {
        if (Number(event.id_usu) === Number(this.$store.state.token.clu_iu)) {
          switch (event.interacoes) {
            case 'l':
            case 'el':
            case 'le':
              // DIMINUI AS INFORMAÇOES DO ID
              this.regAteTimeLineAdicionarRemoverNaoLidos(event.id_reg_ate_pai, -1)

              if (this.interacao.lido.indexOf(event.id) === -1) {
                this.interacao.lido.push(event.id.toString())
              }
              break
          }
        }

        // CRIA O VETOR PARA ATUALIZAÇÃO
        var mensagem = {}

        // VERIFICA SE FOI ENTREGUE A TODOS
        if (event.entregue_todos === '1') {
          mensagem.distributed = true
        }

        // VERIFICA SE FOI LIDO POR TODOS
        if (event.lido_todos === '1') {
          mensagem.seen = true
        }

        // VERIFICA SE TEM QUE ATUALIZAR ALGUMA MENSAGEM
        if (Object.keys(mensagem).length >= 1 && Number(event.id_reg_ate_pai) === this.roomId) {
          // VERIFICA SE O VALOR JÁ EXISTE NO VETOR
          var indexI = this.messages.findIndex(item => item._id === Number(event.id))

          // VERIFICA SE A MENSAGEM FOI ENCONTRADA
          if (indexI !== -1) {
            // PEGA AS MENSAGENS DO VETOR
            var _messages = JSON.parse(JSON.stringify(this.messages))
  
            // SETA OS NOVOS VALORES
            _messages[indexI] = Object.assign(_messages[indexI], mensagem)
  
            // SETA AS MENSAGENS TRABALHADAS
            this.messages = _messages
          }
        }
      },
      regAteTimeLineAdicionarRemoverNaoLidos: function (id, value = 0) {
        // PEGA A CHAVE DO ASSUNTO SOLICITADO
        var indexA = this.assuntos.findIndex(item => Number(item.roomId) === Number(id))

        // ADICIONA A MENSAGEM NÃO LIDA AO VETOR
        if (indexA !== -1) {
          this.assuntos[indexA].unreadCount += value
        }
      },
      regAteTimeLineMarcarEntregueLido: function (ws = false) {
        if (this.marcar.entregue.length >= 1 || this.marcar.lido.length >= 1) {
          // PEGA OS VALORES EXISTENTES
          var valores = JSON.parse(JSON.stringify(this.marcar))

          // REMOVE OS VALORES QUE SERÃO PROCESSADOS
          this.marcar.entregue = this.marcar.entregue.filter(item => valores.entregue.indexOf(item) === -1)
          this.marcar.lido = this.marcar.lido.filter(item => valores.lido.indexOf(item) === -1)

          // valores.entregue = [ valores.entregue[0] ]
          // valores.lido = [ valores.lido[0] ]

          // INICIA O VETOR QUE SERÁ ENVIADO PARA API
          var formData = { j_id_entregue: JSON.stringify(valores.entregue), j_id_lido: JSON.stringify(valores.lido) }

          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/reg-atendimento/interacao', 'PUT', formData, (apiSuccess) => {
            // PEGA O RETORNO DA API
            var retorno = apiSuccess.lot

            // TRABALHA O RETORNO
            for (var indexR in retorno) {
              if ([ '', null, undefined ].indexOf(retorno[indexR].ref) === -1 && [ '', null, undefined ].indexOf(retorno[indexR].ref.id_reg_atendimento) === -1) {
                // MARCA A MENSAGEM COMO ENTREGUE
                if (valores.entregue.indexOf(retorno[indexR].ref.id_reg_atendimento) !== -1) {
                  switch(retorno[indexR].code) {
                    case '200':
                      this.interacao.entregue.push(retorno[indexR].ref.id_reg_atendimento)
                      break

                    default:
                      this.marcar.entregue.push(retorno[indexR].ref.id_reg_atendimento)
                      break
                  }
                }
                
                // MARCA A MENSAGEM COMO ENTREGUE
                if (valores.lido.indexOf(retorno[indexR].ref.id_reg_atendimento) !== -1) {
                  switch(retorno[indexR].code) {
                    case '200':
                      if (ws === false) {
                        this.interacao.lido.push(retorno[indexR].ref.id_reg_atendimento)
                      }
                      break

                    default:
                      this.marcar.lido.push(retorno[indexR].ref.id_reg_atendimento)
                      break
                  }
                }
              }
            }
          }, this.regAteTimeLineSetarStatusGeral)
        }
      },
      regAteTimeLineAbrirCadastro: function (id_contato) {
        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO', tipo: 'contato', id: id_contato, nome: '' }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO', params)
      },
      regAteTimeLineCabecalhoAlterarEditar: function () {
        this.regAteTimeLineCabecalhoBuscarClu().then(() => {
          // SETA SE DEVE ABRIR OU FECHAR O EDITAR
          this.editar = !this.editar
  
          // VERIFICA SE DEVE ABRIR A TELA
          if (this.editar === true) {
            // PEGA O ASSUNTO ABERTO
            var assunto = JSON.parse(JSON.stringify(this.assuntos.filter(item => item.roomId === this.roomId)))[0]

            // SETA O STATUS DO BUTTON
            this.cabecalhoEditarButtons.env.status = ''
  
            // VERIFICA SE OS CAMPO EXISTE
            if ([ '', null, undefined ].indexOf(this.cabecalhoEditar.clu) === -1) {
              this.optionsClu = []
              this.cabecalhoEditar.clu.status = ''
              this.cabecalhoEditar.clu.value = assunto.clu.toString()
              this.cabecalhoEditar.clu.valueIni = assunto.clu.toString()
              this.cabecalhoEditar.clu.options = this.optionsClu
              this.cabecalhoEditar.clu.mostrar = this.optionsClu.length >= 2
            }
            if ([ '', null, undefined ].indexOf(this.cabecalhoEditar.status) === -1) {
              this.cabecalhoEditar.status.status = ''
              this.cabecalhoEditar.status.value = assunto.id_status.toString()
              this.cabecalhoEditar.status.valueIni = assunto.id_status.toString()
              this.cabecalhoEditar.status.options = this.optionsSta
            }
            if ([ '', null, undefined ].indexOf(this.cabecalhoEditar.responsavel) === -1) {
              this.cabecalhoEditar.responsavel.status = ''
              this.cabecalhoEditar.responsavel.value = assunto.responsavel_user.toString()
              this.cabecalhoEditar.responsavel.valueIni = assunto.responsavel_user.toString()
              this.cabecalhoEditar.responsavel.options = this.$store.state.usuarios_reg_ate
            }
          }
        })
      },
      regAteTimeLineCabecalhoOnChange: function (value, id) {
        // PEGA OS DADOS RECEBIDOS
        var index = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.cabecalhoEditar[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.cabecalhoEditar[index].mensagem = ''
        this.cabecalhoEditar[index].mensagemTipo = ''
      },
      regAteTimeLineCabecalhoBuscarStatus: function () {
        return new Promise((success) => {
          // INICIA O QUERYGET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null, notificar: null }, where: { f: 'status', o: '=', v: '1' } }
  
          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/reg-atendimento/config/status/get/', 'GET', queryGet, (apiSuccess) => {
            // SETA O VALOR RECEBIDO
            this.optionsSta = apiSuccess.data
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // FINALIZA O PROCESSO DE BUSCA
            success()
          }, this.regAteTimeLineSetarStatusGeral)
        })
      },
      regAteTimeLineCabecalhoBuscarClu: function () {
        return new Promise((success) => {
          if ([ '', null, undefined ].indexOf(this.cabecalhoEditar.clu) === -1 && this.editar === false) {
            // PEGA O ASSUNTO ABERTO
            var assunto = JSON.parse(JSON.stringify(this.assuntos.filter(item => item.roomId === this.roomId)))[0]

            // INICIA O QUERY GET
            var queryGet = { type: 'list', limit: { row: 0, qty: 10 }, field: { clu: null, cliente: null, cnpj: null } , order: { clu: 'desc' } }

            // PEGA APENAS AS LICENÇA DE USOS DESTE CONTATO
            queryGet.where = { f: 'id_con_subase', o: '=', v: assunto.id_contato }

            // FAZ A BUSCA DOS REGISTROS NA API
            this.$store.state.comunicaAPI('/subase/cli-rotinafacil/get', 'POST', queryGet, (apiSuccess) => {
              // SETA O VALOR RECEBIDO
              this.optionsClu = apiSuccess.data
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // FINALIZA O PROCESSO DE BUSCA
              success()
            }, this.regAteTimeLineSetarStatusGeral)
          } else {
            success()
          }
        })
      },
      regAteTimeLineCabecalhoSalvarAlteracao: function () {
        // SETA O STATUS DO BUTTON
        this.cabecalhoEditarButtons.env.status = 'carregando'

        // PEGA O ASSUNTO ABERTO
        var assunto = JSON.parse(JSON.stringify(this.assuntos.filter(item => item.roomId === this.roomId)))[0]

        // INICIA O VETOR QUE VAI ADICIONAR AS MENSAGENS
        var mensagens = []

        // INICIA O FORMULARIO QUE VAI ENVIAR PARA API
        var formData = {}

        for (var indexC in this.cabecalhoEditar) {
          if (this.cabecalhoEditar[indexC].valueIni !== this.cabecalhoEditar[indexC].value) {
            // INICIA A MENSAGEM QUE DEVE SER SALVA
            var mensagem = 'O Usuário (' + this.$store.state.usuario.usuario + ') alterou '

            // VERIFICA A MENSAGEM QUE DEVE SER ADICIONADA
            switch(indexC) {
              case 'clu':
                // SETA A MENSAGEM QUE DEVE SER ADICIONADA
                mensagem += 'a CLU de (' + assunto.clu + ') para (' + this.cabecalhoEditar[indexC].value + ').'

                // SETA O NOVO VALOR
                formData.clu = this.cabecalhoEditar[indexC].value
                break

              case 'responsavel':
                // PEGA OS DADOS DO USUARIO
                var usuario = this.$store.state.usuarios.filter(item => item.id ===  this.cabecalhoEditar[indexC].value)

                // SETA A MENSAGEM
                mensagem += 'o responsável de (' + assunto.responsavel.usuario + ') para (' + usuario[0].usuario + ').'

                // SETA O NOVO VALOR
                formData.responsavel_user = this.cabecalhoEditar[indexC].value
                break

              case 'status':
                // PEGA OS DADOS DO USUARIO
                var status = this.optionsSta.filter(item => item.id ===  this.cabecalhoEditar[indexC].value)

                // SETA A MENSAGEM
                mensagem += 'o status de (' + assunto.id_status_nome + ') para (' + status[0].nome + ').'

                // SETA O NOVO VALOR
                formData.id_status = this.cabecalhoEditar[indexC].value
                break
            }

            // ADICIONA NO VETOR A MENSAGEM
            mensagens.push(mensagem)
          }
        }

        // VERIFICA SE TEM ALGUAM COISA PARA ATUALIZAR
        if (Object.keys(formData).length === 0) {
          this.regAteTimeLineCabecalhoAlterarEditar()
        } else {
          // SETA O ID QUE DEVE FICAR ABERTO
          this.assuntoOr = [ this.roomId ]

          // SETA O ID DO REGISTRO
          formData.id = this.roomId

          // CONVERTE O REGISTRO EM LOT
          formData = { lot: [ formData ] }
  
          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/reg-atendimento', 'PUT', formData, (apiSuccess) => {
            // PEGA OS VALORES RECEBIDOS
            var retorno = apiSuccess.lot[0]

            // VERIFICA SE DEU ALGUM ERRO PARA INSERIR
            if (retorno.code !== '200') {
              this.$store.state.msgWarn('API [' + retorno.code + ']: ' + retorno.message, 'danger')
            }

            // VERIFICA SE O WS FOI ENVIADO
            if (retorno.code === '200' && ([ '', null, undefined ].indexOf(retorno.ws) !== -1 || retorno.ws.code !== '200')) {
              // INICIA A MENSAGEM
              var erroWS = { cod: '500', loc: 'WS', err: '' }

              // SETA O CODIGO RECEBIDO
              if ([ '', null, undefined ].indexOf(retorno.ws) === -1 && [ '', null, undefined ].indexOf(retorno.ws.code) !== -1) {
                erroWS.cod += retorno.ws.code
              }

              // SETA A MENSAGEM RECEBIDA
              if ([ '', null, undefined ].indexOf(retorno.ws) === -1 && [ '', null, undefined ].indexOf(retorno.ws.message) === -1) {
                erroWS.err += retorno.ws.message
              } else {
                erroWS.err += 'OPS! Não foi possível enviar a mensagem neste momento aos outros usuários. Por favor entre em contato com nosso suporte.'
              }

              // SETA O ERRO NA MASCARA
              this.regAteTimeLineSetarStatusGeral(erroWS)
            }
            
            // VERIFICA SE DEVE INSERIR AS MENSAGENS
            if (retorno.code === '200') {
              for (var indexM in mensagens) {
                this.regAteTimeLineEnviarMensagem({ roomId: this.roomId, content: mensagens[indexM] })
              }
            }

            // CHAMA A FUNÇÃO PARA ATUALIZAR
            this.regAteTimeLineCabecalhoAlterarEditar()
          }, this.regAteTimeLineSetarStatusGeral)
        }
      },
      regAteTimeLineAbrirOpcoes: function (id) {
        if (this.opcoes.indexOf(id) === -1) {
          this.opcoes.push(id)
        } else {
          this.opcoes = this.opcoes.filter(item => item !== id)
        }
      },
      regAteTimeLineOpcoesOnClick: function (tipo, message, referencia) {
        // PEGA OS CAMPOS EXISTENTES
        var children = this.$refs.chat.$children

        // PROCURA O COMPONENT QUE VAI ENVIAR A MENSAGEM
        children = children.filter(item => typeof item.replyMessage === 'function')

        // PEGA O COMPONENT QUE VAI ENVIAR A MENSAGEM
        children = children[0]

        // VERIFICA SE A AÇÃO QUE DEVE REALIZAR
        switch (tipo) {
          case 'responder':
            children.replyMessage(message)
            break

          case 'delete':
            this.regAteTimeLineCabecalhoExcluirTipo(message._id, 'msg')
            break

          case 'delete_room':
            this.regAteTimeLineCabecalhoExcluirTipo(message.roomId, 'assunto')
            break

          case 'suporte':
            // SETA OS PARAMETROS PARA INICIAR
            var params = { tipo: 'REGISTRO_ATENDIMENTO_INICIAR', contatoId: message.id_contato, assuntoId: message.roomId, clu: message.clu }

            // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
            this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
            break

          case 'dados':
            this.regAteTimeLineCabecalhoDadosMensagem(message._id)
            break

          case 'favoritos':
            this.regAteTimeLineCabecalhoFavoritoMensagem(message)
            break
        }

        // CHAMA A FUNÇÃO PARA FECHAR AS OPÇÕES
        this.regAteTimeLineAbrirOpcoes(referencia)
      },
      regAteTimeLineCabecalhoDadosMensagem: function (id = null) {
        this.detalhe = id
      },
      regAteTimeLineCabecalhoFavoritoMensagem: function (message) {
        // MONTA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = { j_id: JSON.stringify([ message._id ]) }

        // SETA A ROTA QUE DEVE UTILIZAR
        var route = [ '', null, undefined ].indexOf(message.favorito) === -1 ? '/reg-atendimento/desfavoritar' : '/reg-atendimento/favoritar'

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI(route, 'PUT', formData, (apiSuccess) => {
          this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
        }, this.regAteTimeLineSetarStatusGeral, (apiValid, apiStatus) => {
          this.$store.state.FUN_API_RET_VALIDA(this, 'formulario', apiValid, apiStatus, {}, true, null)
        })
      },
      regAteTimeLineCabecalhoExcluirTipo: function (id, tipo) {
        // INICIA A VARIAVEL PARA MENSAGEM
        var message = ''

        // VERIFICA A MENSAGEM QUE DEVE APRESENTAR
        switch (tipo) {
          case 'assunto':
            message = 'Deseja realmente excluir este atendimento?'
            break

          case 'msg':
            message = 'Deseja realmente excluir está mensagem?'
            break
        }

        // CONFIRMA A EXCLUSÃO
        if (window.confirm(message)) {
          // MONTA O FORMULARIO QUE SERÁ ENVIADO PARA API
          var formData = { lot: [ { id: id } ] }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/reg-atendimento', 'DELETE', formData, (apiSuccess) => {
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
          }, this.regAteTimeLineSetarStatusGeral)
        }
      },
      regAteTimeLineSetarRespostasMensagen: function (callback = null, mensagens = []) {
        // INICIA O VETOR QUE VAI RECEBER AS ATUALIZAÇÕES
        var vetor = []

        // PEGA OS IDS QUE DEVE BUSCAR NA API
        var ids = []

        // PEGA AS MENSAGENS
        if (mensagens.length === 0) {
          mensagens = JSON.parse(JSON.stringify(this.messages))
        }

        // VERIFICA SE TEM MENSAGENS PARA SER CITADAS
        for (var indexM in mensagens) {
          if ([ '', null, undefined, '0', 0 ].indexOf(mensagens[indexM].id_reg_ate_citar) === -1 && ([ '', null, undefined ].indexOf(mensagens[indexM].vetor_resposta) !== -1 || Object.keys(mensagens[indexM].vetor_resposta).length === 0)) {
            // PEGA A MENSAGEM QUE DEVE ATUALIZAR
            var mensagem = mensagens.filter(item => item._id === mensagens[indexM].id_reg_ate_citar)

            if (mensagens[indexM].id_reg_ate_citar === 258) {
              mensagem = []
            }

            // SETA OS DADOS DA MESNAGEM ENCONTRADA
            if (mensagem.length >= 1) {
              vetor.push(JSON.parse(JSON.stringify(mensagem[0])))
            } else {
              ids.push(mensagens[indexM].id_reg_ate_citar)
            }
          }
        }

        // BUSCA AS MENSAGENS FALTANTES
        this.regAteTimeLineBuscarRespostasMensagen(ids, (retornos) => {
          // JUNTA OS DOIS VALORES EXISTENTES
          vetor = vetor.concat(retornos)

          // VERIFICA SE TEM MENSAGENS PARA SER CITADAS
          for (var index in mensagens) {
            if ([ '', null, undefined, '0', 0 ].indexOf(mensagens[index].id_reg_ate_citar) === -1 && ([ '', null, undefined ].indexOf(mensagens[index].vetor_resposta) !== -1 || Object.keys(mensagens[index].vetor_resposta).length === 0)) {
              // PEGA A MENSAGEM QUE DEVE ATUALIZAR
              var mensagem = vetor.filter(item => (Number(item._id) === Number(mensagens[index].id_reg_ate_citar)) || (Number(item.id) === Number(mensagens[index].id_reg_ate_citar)))

              // PEGA A MENSAGEM
              mensagem = mensagem[0]

              // SETA A MENSAGEM NO VETOR
              if ([ '', null, undefined, '0', 0 ].indexOf(mensagem.content) === -1) {
                mensagens[index].vetor_resposta = {
                  mensagem: mensagem.content,
                  username: mensagem.username,
                  usuario_cor: mensagem.usuario_cor
                }
              } else {
                // SETA A MENAGEM RECEBIDA
                mensagens[index].vetor_resposta = { mensagem: mensagem.comentario }

                // PEGA OS DADOS DO USUARIO
                var usuario = this.$store.state.usuarios.filter(item => item.id === mensagem.last_user)
      
                // SETA O ID DA MENSAGEM
                if (usuario.length >= 1) {
                  // SETA O NOME DO USUARIO
                  mensagens[index].vetor_resposta.username = usuario[0].usuario

                  // SETA A COR DO CONTATO
                  mensagens[index].vetor_resposta.usuario_cor = this.cores.filter(item => item.chave === usuario[0].id)
          
                  // VERIFICA SE FOI ENCONTRADO ALGUMA REGISTRO
                  mensagens[index].vetor_resposta.usuario_cor = mensagens[index].vetor_resposta.usuario_cor.length >= 1 ? mensagens[index].vetor_resposta.usuario_cor[0] : null
        
                  // SE NÃO EXISTIR COR, GERA UMA NOVA COR PARA ESTE REGISTRO
                  if (mensagens[index].vetor_resposta.usuario_cor === null) {
                    // GERA AS NOVAS CORRES PARA OS CAMPOS
                    var cor = FUN_RANDOM_COLOR()
        
                    // SETA O VALOR RECEBIDO
                    mensagens[index].vetor_resposta.usuario_cor = { chave: mensagens[index].vetor_resposta.responsavel_user, borda: cor[0], fundo: cor[1], letra: cor[2] }
                    
                    // ADICIONA O VALOR GERADO NO VETOR
                    this.cores.push(mensagens[index].vetor_resposta.usuario_cor)
        
                    // SALVA NO BANCO DE DADOS PARA NÃO PRECISAR GERAR NOVAMENTE
                    BD_TABLE_INSERT('cores', mensagens[index].vetor_resposta.usuario_cor, 'GERAL')
                  }
                }
              }
            }
          }

          // SETA OS DADOS DAS MENSAGENS ATUALIZADAS
          this.messages = mensagens

          // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      regAteTimeLineBuscarRespostasMensagen: function (ids = [], callback, qtde = 300, ini = null, fim = null, retornos = []) {
        // SETA OS DADOS QUE SERÁ BUSCADO
        if (ini === null && fim === null) {
          ini = 0
          fim = qtde
        } else if (ids.length > (ini + qtde)) {
          ini += qtde
          fim += qtde
        } else {
          ini = null
          fim = null
        }

        if (ini !== null && fim !== null && ids.length >= 1) {
          // INICIA O QUERYGET QUE SERÁ FEITO NA API
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }
  
          // SETA O WHERE PARA PEGAR OS REGISTROS PAÍS
          queryGet.where = { aAnd: [ { f: 'id_reg_ate_pai', o: '=', v: this.roomId }, { f: 'id', o: 'in', v: ids.slice(ini, fim).join(',') } ] }
  
          // SETA A ORDEM QUE DEVE RETORNAR
          queryGet.order = { last_at: 'desc' }
  
          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/reg-atendimento/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            retornos = retornos.concat(apiSuccess.data)
            
            // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
            this.regAteTimeLineBuscarRespostasMensagen(ids, callback, qtde, ini, fim, retornos)
          }, this.regAteTimeLineSetarStatusGeral)
        } else {
          callback(retornos)
        }
      },
      regAteTimeLineFiltroClick: function () {
        if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros.filtroBT) === -1) {
            this.$refs.filtros.filtroBT.onClick()
          }
        }
      },
      regAteTimeLineFiltroOnChangeFiltrado: function (value) {
        // SETA O VALOR RECEBIDO
        this.filtros.filtrando = value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteTimeLineReceberArquivo: function (event) {
        // INICIA A CHAVE QUE SERÁ UTILIZADA
        var chave = ''

        // RECEBE OS IDS QUE DEVE ADICONAR NA PAGINA
        var adicionar = []

        // RODA O VETOR RECEBIDO
        for (var indexF in event) {
          if ([ '', null, undefined ].indexOf(event[indexF].id_reg_atendimento) === -1) {
            // PEGA A CHAVE DO VETOR
            chave = event[indexF].id_reg_atendimento

            // CONVERTE A CHAVE QUANDO É UM ARQUIVO COM LINK DE DOWNLOAD
            if ([ '', null, undefined ].indexOf(event[indexF].thumbnail_b64) !== -1 && [ '', null, undefined ].indexOf(event[indexF].link_download) === -1) {
              event[indexF].thumbnail_b64 = event[indexF].link_download
            }

            // VERIFICA SE A MENSAGEM EXISTE PARA O ARQUIVO
            if ([ '', null, undefined ].indexOf(this.msgAguardandoFile[chave]) === -1) {
              // ADICONA O ARQUIVO AO VETOR
              this.msgAguardandoFile[chave].files.push(event[indexF])

              // SETA QUAL CHAVE DEVE ADICIONAR NA TELA
              adicionar.push(chave)
            }
          }
        }

        // ADICONA TODAS AS IMAGENS PRONTAS
        for (var indexA in adicionar) {
          // PEGA A CHAVE DO VETOR
          chave = adicionar[indexA]

          // ADICIONA O ARQUIVO NA TELA
          this.regAteTimeLineAdicionarMensagem([ JSON.parse(JSON.stringify(this.msgAguardandoFile[chave])) ], true)

          // REMOVE O ARQUIVO QUE FOI ADICIONADO
          delete this.msgAguardandoFile[chave]
        }
      },
      regAteTimeLineTratarInput: function () {
        if (this.statusRooms === false && this.statusMessage === false && [ '', null, undefined ].indexOf(document.querySelectorAll) === -1) {
          if ([ '', null, undefined ].indexOf(this.roomId) === -1) {
            // PEGA A DIV QUE EXISTE NA TELA
            var itens = document.querySelectorAll('.box-footer textarea')
            
            // VERIFICA SE FOI LOCALIZADO O CAMPO
            if (itens.length === 0) {
              itens = document.querySelectorAll('.vac-box-footer textarea')
            }
            
            // VERIFICA SE FOI ENCONTRADO ALGUM ITEM NA TELA
            if (itens.length >= 1) {
              // CRIA A VARIAVEL QUE VAI RECEBER OS DADOS
              var elemento = itens[0]

              // ADICIONA O OBSERVADOR NO CAMPO
              elemento.addEventListener('paste', this.regAteTimeLineOnPasteTextArea)
            }
          }
        }
      },
      regAteTimeLineOnPasteTextArea: function (event) {
        // PEGA O ARQUIVO
        var arquivo = [ '', null, undefined ].indexOf(event.clipboardData) === -1 ? event.clipboardData : event.target

        // VERIFICA SE TEM ARQUIVO
        if ([ '', null, undefined ].indexOf(arquivo.files) === -1 && arquivo.files.length >= 1) {
          // PEGA OS CAMPOS EXISTENTES
          var children = this.$refs.chat.$children
  
          // PROCURA O COMPONENT QUE VAI ENVIAR A MENSAGEM
          children = children.filter(item => typeof item.onFileChange === 'function')
  
          // PEGA O COMPONENT QUE VAI ENVIAR A MENSAGEM
          children = children[0]
  
          // CHAMA A FUNÇÃO PARA SETAR O ARQUIVO RECEBIDO
          children.onFileChange(arquivo.files)
        }
      },
      regAteTimeLineMostrarOcultarAssuntos: function () {
        // PEGA OS CAMPOS EXISTENTES
        var children = this.$refs.chat.$children

        // PROCURA O COMPONENT QUE VAI ENVIAR A MENSAGEM
        children = children.filter(item => [ '', null, undefined ].indexOf(item._events) === -1 && [ '', null, undefined ].indexOf(item._events['toggle-rooms-list']) === -1)

        // PEGA O COMPONENT QUE VAI ENVIAR A MENSAGEM
        if (children.length >= 1) {
          children = children[0]._events['toggle-rooms-list']

          // VERIFICA SE EXISTE A FUNÇÃO SOLICITADA
          if (children.length >= 1) {
            children = children[0]
          }
        }

        // EXECUTA A FUNÇÃO SE ELA EXISTIR
        if (typeof children === 'function') {
          children()
        }
      }
    },
    watch: {
      statusMessage: function () {
        this.regAteTimeLineTratarInput()
      }
    }
  }
</script>

<style scoped>
.reg-ate {
  /* z-index: 3001; */
  z-index: 2796;
  position: fixed;
  top: 68px;
  width: 100%;
  height: calc(100% - 68px);
}

.reg-ate-avatar {
  height: 42px;
  width: 42px;
  min-height: 42px;
  min-width: 42px;
  margin: 0px auto;
  /* margin-right: 15px; */
  border-radius: 50%;
  text-align: center;
  font-size: 25px;
  line-height: 38px;
  opacity: 0.85;
}
  .reg-ate-avatar > img,
  .reg-ate-avatar-clu > img {
    height: calc(100% + 2px);
    width: calc(100% + 2px);
    border-radius: 50%;
    margin-top: -1px;
    margin-left: -1px;
  }

.reg-ate-avatar-clu {
  width: 50px;
  min-width: 50px;
  margin-top: 3px;
  border-radius: 5px;
  text-align: center;
  font-size: 13px;
  opacity: 0.85;
}

.reg-ate-typing {
  display: block;
  overflow: hidden;
  color: #07bc4c;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.room-badge,
.vac-room-badge {
  text-align: center;
  font-weight: 700;
  width: auto;
  min-width: 23px;
  height: auto;
  min-height: 23px;
  font-size: 10px;
  /* line-height: 10px; */
  vertical-align: middle;
  padding: .2em .5em .2em .5em;
  -webkit-transform: scaleX(1) scaleY(1);
  transform: scaleX(1) scaleY(1);
  border-radius: 1.1em;
  margin: 2px;
  opacity: 0.60;
}
.room-badge:last-child,
.vac-room-badge:last-child {
  margin-right: 0px;
}
 .room-badge,
 .vac-room-badge {
   background: #539033;
 }

.reg-ate-nlidos {
  background: #2687e9;
  color: #fff;
}
.reg-ate-forma > svg {
  font-size: 13px;
  color: #ffffff;
  height: 18px;
}

.reg-ate-time-line-cab-editar {
  width: 92px;
  min-width: 92px;
  max-width: 92px;
  text-align: right;
}
  .reg-ate-time-line-cab-editar > div {
    display: inline-block;
    vertical-align: bottom;
    margin: 5px;
    text-align: center;
    cursor: pointer;

    height: 35px;
    width: 35px;
    min-height: 35px;
    min-width: 35px;
    /* margin-right: 15px; */
    border-radius: 50%;
    text-align: center;
    font-size: 18px;
    line-height: 32px;
    opacity: 0.85;
  }

.reg-ate-time-line-msg-check {
  margin-left: 2px;
  margin-right: -5px;
}
  .reg-ate-time-line-msg-check > svg {
    color: #c1cadc;
  }
  .reg-ate-time-line-msg-check.azul > svg {
    color: #69b6f3;
  }
  .two-check > svg:last-child {
    margin-top: -11px;
    margin-left: -4px;
  }

.reg-ate-cabecalho-editar {
  width: 100%;
}

.reg-ate-cabecalho-editar-rodape-right {
  text-align: right;
}
  .reg-ate-cabecalho-editar-rodape-right > button {
    margin: 0px 5px;
  }

.vac-message-container > .vac-message-card > .vac-options-container {
  display: none;
}
.vac-message-container:hover > .vac-message-card >  .vac-options-container {
  display: block;
}
  .vac-message-container > .vac-message-card > .vac-options-container > span > .vac-options-me {
    position: absolute;
    height: 20px;
    width: 60px;
    border-bottom-left-radius: 10px;
  }
  .vac-message-container > .vac-message-card > .vac-options-container > span > .vac-options-me {
    background: var(--chat-message-bg-color);
    opacity: 0.65;
  }
  .vac-message-container > .vac-message-current > .vac-options-container > span > .vac-options-me {
    background: var(--chat-message-bg-color-me);
    opacity: 0.65;
  }
    .vac-message-container > .vac-message-card > .vac-options-container > span > .reg-ate-msg-acoes {
      width: 25px;
      height: 20px;
      text-align: right;

      background: rgb(136 136 136 / 0.20);
      position: absolute;
      right: 0;
      top: 0px;
      padding-right: 7px;
      /* padding-top: 4px; */
      border-bottom-left-radius: 10px;
    }
    .vac-message-container > .vac-message-card > .vac-options-container > span > .reg-ate-msg-acoes > svg {
      cursor: pointer;
      font-size: 14px;
      opacity: 0.65;
    }

  .vac-menu-options-bg {
    /* background: red; */
    position: fixed;
    z-index: 1000000;
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px;
  }

  
  .vac-message-card:not(.vac-message-current) > .vac-menu-options {
    margin-right: -45px;
  }
  .vac-menu-options {
    z-index: 1000001;
  }
    .vac-menu-options > .vac-menu-list > div:hover {
      background: #ccc;
    }

  .reg-ate-msg-excluida {
    opacity: .60;
    cursor: no-drop;
  }
    .reg-ate-msg-excluida > div {
      padding: 2px 10px 7px 0px;
    }
      .reg-ate-msg-excluida > div > svg {
        font-size: 14px;
        margin-right: 5px;
      }


  .vac-room-options {
    padding-left: 10px;
  }
    .vac-room-options > svg {
      font-size: 25px;
    }
  .reg-ate-search > .vac-icon-search {
    cursor: pointer;
    left: 65px;
  }
  .reg-ate-search > .vac-icon-search > svg {
    color: #a2abb4;
    font-size: 20px;
  }
  
  .reg-ate-search > .icones > svg {
    font-size: 13px;
  }
  
  .reg-ate-search > .fechar { 
    margin-left: 0px;
    margin-right: 5px;
    padding: 8px 10px;
  }
  .reg-ate-search > .fechar > svg { 
    font-size: 15px;
  }

@keyframes icone-piscando {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 0; }
}
.piscando > svg {
  -webkit-animation: icone-piscando 1s ease-in-out infinite alternate;
  -moz-animation: icone-piscando 1s ease-in-out infinite alternate;
  -ms-animation: icone-piscando 1s ease-in-out infinite alternate;
  -o-animation: icone-piscando 1s ease-in-out infinite alternate;
  animation: icone-piscando 1s ease-in-out infinite alternate;
}
.buscando {
  width: calc(100% + 10px);
}
.limpar-search {
  margin-left: -18px;
  color: #a2abb4;
  cursor: pointer;
}
  .limpar-search:hover {
    color: #444
  }
</style>

<style>
.reg-ate-images > .cpnt-arm-arq-icone {
  margin-left: 0px !important;
  padding-left: 0px !important;
  width: auto !important;
  min-width: initial !important;
  max-width: initial !important;
}
.reg-ate-cabecalho-editar {
  width: 100%;
  padding-top: 25px;
}
.reg-ate-cabecalho-editar > .rf-cpnt-group {
  margin-right: 0px;
  margin-bottom: 25px;
}
.reg-ate-cabecalho-editar > .rf-cpnt-group,
.reg-ate-cabecalho-editar > .rf-cpnt-group > .rf-input-group {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
}
.reg-ate > .card-window > .chat-container > .rooms-container > .box-search:not(.reg-ate-search),
.reg-ate > .vac-card-window > .vac-chat-container > .vac-rooms-container > .vac-box-search:not(.reg-ate-search) {
  visibility: hidden !important;
  display: none !important;
}
.reg-ate > .card-window > .chat-container > .col-messages,
.reg-ate > .vac-card-window > .vac-chat-container > .vac-col-messages,
.reg-ate > .card-window > .chat-container > .col-messages > .container-scroll,
.reg-ate > .vac-card-window > .vac-chat-container > .vac-col-messages > .vac-container-scroll {
  background: #e5ddd5 !important;
  background-repeat: repeat !important;
  background-image: url('./bg-chat-time-line-msg_2.png') !important;
}
.conexao_SuporteRF {
  width: 100%;
  padding: 0px;
  margin: 0px;
  text-align: left !important;
  word-break: initial;
  white-space: initial;
  word-wrap: initial;
}
  .conexao_SuporteRF  > tr > td {
    padding: 0px;
    margin: 0px;
    vertical-align: top;
  }
  .conexao_SuporteRF  > tr > .icone {
    width: 35px;
    text-align: left;
    padding-right: 5px;
    font-size: 11px;
  }
    .conexao_SuporteRF  > tr > .icone > svg {
      font-size: 30px;
    }
  .conexao_SuporteRF  > tr > .conteudo {
    text-align: left;
  }
    .conexao_SuporteRF  > tr > .conteudo > span {
      font-size: 12px;
      word-break: break-all;
    }
    .conexao_SuporteRF  > tr > .conteudo > svg {
      font-size: 15px;
      margin-right: 5px;
      vertical-align: -3px;
    }
.reg-ate-search > .icones > .filtro-busca-telas > div {
  float: none !important;
  width: auto;
  height: auto;
}
.reg-ate-search > .icones > .filtro-busca-telas > div > button {
  width: auto;
  height: auto;
  border: none;
  margin: 0px;
  padding: 0px;
}
.reg-ate-search > .icones > .filtro-busca-telas > div > button,
.reg-ate-search > .icones > .filtro-busca-telas > div > button:hover {
  background: none;
  box-shadow: none;
}
.reg-ate-search > .icones {
  margin-left: 5px;
  border-radius: 50%;
  padding: 10px;
  border: 1px solid #ccc;
  text-align: center;
  cursor: pointer;
}
.reg-ate-search > .vac-add-icon { 
  background: #1976d2;
  padding: 10px 11px;
}
.reg-ate-search > .vac-add-icon > svg { 
  color: #fff;
  font-size: 15px;
}
.reg-ate-ocultar-assuntos > svg {
  opacity: 0.60;
  height: 26px !important;
  width: 26px !important;
}
.room-wrapper > .toggle-button:not(.reg-ate-ocultar-assuntos),
.vac-room-wrapper > .vac-toggle-button:not(.reg-ate-ocultar-assuntos) {
  display: none;
}
.room-wrapper > .rotate-icon ~ .info-wrapper > .reg-ate-ocultar-assuntos,
.vac-room-wrapper > .vac-rotate-icon ~ .vac-info-wrapper > .reg-ate-ocultar-assuntos {
  -webkit-transform: rotate(180deg)!important;
  transform: rotate(180deg)!important;
}
.room-list,
.vac-room-list {
  padding: 0 0px 5px !important;
}
.room-item,
.vac-room-item {
  padding: 0px 5px !important;
  border-radius: 0px !important;
}
</style>
